// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23F34E65%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/calender.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/linkedin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/instagram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/twitter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:; image/svg+xml,%3csvgxmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/male_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/female_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/tick.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/scholarships-hat.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/check-tick.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/blue_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/badge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/whatsapp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/form-email.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/form-lock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@100;200;300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Jost', sans-serif;
}
body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.flex-1 {
    flex: 1 1;
}
.bg-skyblue-gradient,
.basic-information {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f3f9ff+0,f7fbff+44,f0f7ff+100 */
    background: #f3f9ff; /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3f9ff', endColorstr='#f0f7ff',GradientType=0 ); /* IE6-9 */
}
.bg-beige-gradient,
.undergraduate-college {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f3f9ff+0,f7fbff+44,f0f7ff+100 */
    background: #fffbf2; /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#FFFBF2', endColorstr='#FEF7E7',GradientType=0 ); /* IE6-9 */
}

/* madhu added */
.bg-purple-gradient {
    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%) 0% 0% no-repeat padding-box !important;
}
/* madhu added */
.bg-green-gradient {
    background: transparent linear-gradient(211deg, #fefffd 0%, #ebffe6 76%, #c6ebbe 100%) 0% 0% no-repeat padding-box !important;
}
.bg-pink-gradient {
    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) 0% 0% no-repeat padding-box !important;
}

.rightPane.basic-information .rightPaneHeaderWrap {
    background: #f3f9ff;
}
.rightPane.undergraduate-college .rightPaneHeaderWrap {
    background: #fffbf2;
}
.rightPane.bg-purple-gradient .rightPaneHeaderWrap {
    background: #efedff;
}
.bg-green-gradient .rightPaneHeaderWrap {
    background: transparent !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
}
.bg-green-gradient .rightPaneHeaderWrap {
    background: transparent !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.bg-pink-gradient .rightPaneHeaderWrap {
    background: transparent !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.green_recom_bg {
    background: transparent linear-gradient(95deg, #5cae48 0%, #27a7df 100%) 0% 0% no-repeat padding-box !important;
    right: 50px !important;
}
.green_recom_bg_left {
    background: transparent linear-gradient(95deg, #5cae48 0%, #27a7df 100%) 0% 0% no-repeat padding-box !important;
    /* right: 50px !important; */
}
.bg_transparant {
    background: transparent !important;
}

.prize_bg {
    background: transparent linear-gradient(94deg, #51499c 0%, #d42941 100%) 0% 0% no-repeat padding-box !important;
}
.laststep_bg {
    background: transparent linear-gradient(101deg, #51499c 0%, #27a7df 100%) 0% 0% no-repeat padding-box !important;
}

/* madhu added */

.user_name span {
    font-weight: 600;
}
.main-wrap {
    flex: 1 1;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background-color: #fff;
}
.main-wrap > .row {
    flex: 1 1;
}

.leftPane {
    width: 57.82%;
}
.leftPaneHeaderWrap {
    padding: 25px 0px;
    border-bottom: 1px solid #e2e8ef;
    display: flex;
    justify-content: end;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 3;
    height: 93px;
}
.leftPaneHeader {
    max-width: 900px;
    width: 96%;
}
.leftPaneHeader .user_name {
    display: none;
}
.leftPaneHeader img {
    height: 100%;
    width: auto;
}
.leftPaneBodyWrap {
    padding: 50px 0;
    display: flex;
    justify-content: end;
}
.leftPaneBody {
    padding: 0 100px;
    max-width: 890px;
    width: 100%;
}

.leftPaneWrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.leftPaneWrap .leftPaneBodyWrap {
    flex: 1 1;
}
.leftPaneBody .qs_body {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.leftPaneBody .qs_body .step {
    flex: 1 1;
}
.leftPaneBody .qs_body .steps {
    flex: 1 1;
}

.leftPaneBody .qs_body .form-check-inline {
    min-height: 45px;
    display: inline-flex;
    align-items: center;
    margin-top: 2px;
}
.leftPaneBody .qs_body .form-check-inline input {
    margin-right: 5px;
    width: 20px;
    height: 20px;
    transition: all 0.3s ease-in-out;
}
.leftPaneBody .qs_body .form-check-inline .form-check-label {
    margin-top: 2px;
}
.progress_svg {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    background: white;
    border-radius: 50%;
}
.global {
    position: absolute;
    background: white;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    bottom: -50px;
    right: -50px;
}
.unlock {
    white-space: nowrap;
    display: flex;
    align-items: center;
    background: transparent linear-gradient(96deg, #f05a2a 0%, #f8b018 100%) 0% 0% no-repeat padding-box;
    border-radius: 30px 0px 0px 30px;
    height: 40px;
    right: 20px;
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 1;
    -webkit-border-radius: 30px 0px 0px 30px;
    -moz-border-radius: 30px 0px 0px 30px;
    -ms-border-radius: 30px 0px 0px 30px;
    -o-border-radius: 30px 0px 0px 30px;
    width: auto;
    transition: all 0.5s ease-in-out;
    opacity: 0;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.unlock_blue {
    background: transparent linear-gradient(95deg, #27a7df 0%, #51499c 100%) 0% 0% no-repeat padding-box !important;
    border-radius: 30px 0px 0px 30px !important;
}

.unlock .img {
    margin: 0 10px 0 5px;
}
.unlock .img img {
    width: 30px;
    height: 30px;
}
.unlock.prize_bg .img,
.unlock.laststep_bg .img {
    display: flex;
    align-items: end;
    height: 100%;
}
.unlock.unlock_blue .img {
    margin: 0 5px 10px -3px;
}
.unlock.green_recom_bg .img {
    display: flex;
    align-items: end;
    height: 100%;
    padding: 0 0 5px 8px;
}
.unlock.prize_bg .img img {
    width: 62px;
    height: auto;
}
.unlock.laststep_bg .img img {
    width: 48px;
    height: auto;
}
.unlock.green_recom_bg .img img {
    width: 43px;
    height: auto;
}
.unlock.unlock_blue .img img {
    width: 57px;
    height: auto;
}

.unlock.prize_bg .img {
    display: flex;
    align-items: end;
    height: 100%;
}
.unlock.prize_bg .img img {
    width: 62px;
    height: auto;
}
.unlock .text {
    line-height: 18px;
    color: #fff;
    padding-right: 30px;
    font-size: 18px;
    font-weight: 400;
    width: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.progress_svg span {
    position: absolute;
    left: auto;
    right: auto;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 25px !important;
    font-weight: 600;
    color: #000 !important;
    line-height: 90px !important;
}
.progress_svg span::after {
    content: '%';
    font-size: 18px !important;
}
.progress_svg .gaugeMeter {
    width: 90px;
    height: 90px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.global.show .unlock .text {
    width: auto;
}
.global.show .unlock {
    right: 80px;
    opacity: 1;
}

.rightPane {
    width: 42.18%;
    display: flex;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.rightPaneWrap {
    flex: 1 1;
}
.rightPaneHeaderWrap {
    min-height: 93px;
    border-bottom: 1px solid #e4e8ef;
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 2;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}

.rightPaneHeader {
    max-width: 600px;
    width: 96%;
    display: flex;
    justify-content: end;
    align-items: center;
}
.rightPaneBodyWrap {
    padding: 50px 60px;
    display: flex;
    position: sticky;
    top: 93px;
}
.rightPaneBody {
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: center;
}

.step {
    display: none;
    flex-direction: column;
}
.step .stepHeader {
    width: 100%;
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
    position: relative;
    padding: 0;
}
/* .step .stepHeader::before {content: '';position: absolute;left: 0;bottom: 0;width: 44px;height: 4px;background: #5cae48;border-radius: 5px;} */
.step_img {
    margin: 0;
}
.step_img img {
    width: inherit;
}
.step p {
    width: 100%;
    margin: 0;
    font-size: 18px;
}

.listed_points {
    margin-top: 20px;
}
.step_header_wrap_link {
    display: none;
}
.listed_points ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.listed_points ul li {
    position: relative;
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 400;
    line-height: 22px;
    padding: 0 0 0 10px;
}
/* madhu modified */
.listed_points ul li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0px;
    width: 3px;
    height: 20px;
    background: #27a7df;
    border-radius: 15px;
}
/* madhu modified */

/* madhu added */
.listed_points ul.beige-line li:before {
    background: #f8b018 !important;
}
.listed_points ul.purple-line li:before {
    background: #51499c !important;
}
.listed_points ul.orange-line li:before {
    background: #f05a2a !important;
}
.listed_points ul.green-line li:before {
    background: #5cae48 !important;
}
.listed_points ul.pink-line li:before {
    background: #ee4c61 !important;
}
/* madhu added */

.undergraduate-college .listed_points ul li::before {
    background: #f8b018;
}

.rightPane.basic-information .step_1 {
    display: flex;
}
.rightPane.undergraduate-college .step_2 {
    display: flex;
}

.steps {
    /*height: 0px;opacity: 0;overflow: hidden;*/
    transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
}
.steps.showTab {
    height: auto;
    opacity: 1;
}
.action_btns #viewcareersbtn {
    display: none;
}
/* madhu modified */
.steps_questions {
    padding: 0 0 0 0px;
    margin-top: 0px;
    /* left: -50px; */
    position: relative;
    /* opacity: 0; */
    transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    max-width: 640px;
}
/* madhu modified */
.steps.showTab .steps_questions {
    /* left: 0px;
    opacity: 1; */
}
.steps_questions h2 {
    font-size: 22px;
    font-weight: 800;
    /* margin-left: 50px; */
    /* opacity: 0; */
    transition: all 0.3s ease-in-out;
}
.steps.showTab h2 {
    margin-left: 0px;
    opacity: 1;
}
.steps_questions h2 span {
    position: relative;
}
.steps_questions h2 span:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2px;
    background: #5dae48;
    border-radius: 5px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.steps_questions h2 span:before {
    width: 100%;
}
.steps.showTab h2 {
    opacity: 1;
    margin-left: 0;
}
.question_wrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.question_number {
    margin-right: 10px;
    display: none;
}
.question_number span {
    width: 33px;
    height: 33px;
    border: 2px solid #dddddd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    color: #000;
}
.question .form-label {
    font-size: 18px;
    font-weight: 500;
    margin-top: 3px;
    margin-bottom: 3px;
}
.question .form-label .info {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #656565;
    border: 1px solid #656565;
    border-radius: 50%;
    font-style: italic;
    font-family: initial;
    font-weight: 600;
    font-size: 12px;
    color: #fff;
}
.question {
    width: 100%;
    position: relative;
}
/* madhu modified */
.main-wrap .form-control {
    max-width: 100%;
    height: 45px;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
    line-height: 30px;
}

.profile_wrap textarea.form-control {
    margin-bottom: 20px;
}
.flex-fill.form-control {
    z-index: inherit;
}
.input-group-text {
    border-color: #b5c2cb;
}
.main-wrap .small-text {
    color: #0b3454;
    font-size: 15px;
}
.main-wrap .form-select {
    max-width: 100%;
    height: 45px;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
}
/* madhu modified */

.form-check-input + label.gap-switch {
    background: #fff;
    padding: 5px;
    border-radius: 25px;
    position: relative;
    width: 100px;
    height: 40px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    border: 2px solid #f34e65;
    color: #f34e65;
}
.form-check-input:checked + label.gap-switch {
    background: #5dae48;
    border-color: #5dae48;
}
.form-check-input + label.gap-switch:before {
    width: 24px;
    height: 24px;
    display: inline-block;
    background: #f34e65;
    border-radius: 50%;
    content: '';
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + label.gap-switch::before {
    transform: translateX(62px);
    -webkit-transform: translateX(62px);
    -moz-transform: translateX(62px);
    -ms-transform: translateX(62px);
    -o-transform: translateX(62px);
    background: #fff;
}
.form-check-input + label.gap-switch:after {
    content: 'NO';
    color: #f34e65;
    flex: 1 1;
    text-align: center;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.form-check-input:checked + label.gap-switch::after {
    transform: translateX(-30px);
    content: 'YES';
    -webkit-transform: translateX(-30px);
    -moz-transform: translateX(-30px);
    -ms-transform: translateX(-30px);
    -o-transform: translateX(-30px);
    color: #fff;
}
.action_btns {
    max-width: 650px;
    background: #f5faff;
    padding: 20px;
    border-radius: 5px;
    margin: 35px 0 0 0px;
    text-align: center;
}
.form-switch .form-check-input:focus,
.form-switch .form-check-input {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    border: 2px solid #f34e65;
    cursor: pointer;
}
.form-check-input:checked {
    background-color: #29a745;
    border-color: #29a745;
}
.form-switch .form-check-input:checked:focus {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    border: 2px solid #29a745;
}
.action_btns button.nextbtn {
    padding: 0px 30px;
    font-size: 1.5em;
    width: 180px;
    cursor: pointer;
    border: 0px;
    position: relative;
    margin: auto;
    transition: all 0.25s ease;
    background: #0b3454;
    color: #fff;
    overflow: hidden;
    border-radius: 25px;
    height: 45px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
}

.load {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    -webkit-border-radius: inherit;
    -moz-border-radius: inherit;
    -ms-border-radius: inherit;
    -o-border-radius: inherit;
}
.load::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    border: 3px solid #fff;
    width: 30px;
    height: 30px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid transparent;
    animation: loading1 1s ease infinite;
    z-index: 10;
    -webkit-animation: loading1 1s ease infinite;
}
.load::before {
    content: '';
    position: absolute;
    border-radius: 50%;
    border: 3px dashed #fff;
    width: 30px;
    height: 30px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid transparent;
    animation: loading1 2s linear infinite;
    z-index: 5;
    -webkit-animation: loading1 2s linear infinite;
}

@keyframes loading1 {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
    }
}
.float_horizontal_animate {
    transform: translatex(0px);
    animation: float_horizontal 4s ease-in-out infinite;
    -webkit-animation: float_horizontal 4s ease-in-out infinite;
}

@keyframes float_horizontal {
    0% {
        transform: translatex(0px);
        -webkit-transform: translatex(0px);
        -moz-transform: translatex(0px);
        -ms-transform: translatex(0px);
        -o-transform: translatex(0px);
    }
    50% {
        transform: translatex(-10px);
        -webkit-transform: translatex(-10px);
        -moz-transform: translatex(-10px);
        -ms-transform: translatex(-10px);
        -o-transform: translatex(-10px);
    }
    100% {
        transform: translatex(0px);
        -webkit-transform: translatex(0px);
        -moz-transform: translatex(0px);
        -ms-transform: translatex(0px);
        -o-transform: translatex(0px);
    }
}

button .loading {
    opacity: 0;
    visibility: hidden;
}
button.activeLoading .loading {
    visibility: visible;
    opacity: 1;
}

.question .form-select.max-100 {
    max-width: 100%;
}

.check_box {
    background: #f5f7f8 0% 0% no-repeat padding-box;
    border-radius: 6px;
    min-height: 48px;
    padding: 12px 20px 10px;
    margin: 20px 0 -35px 0;
    max-width: 640px;
}

.check_box .form-check-input {
    width: 20px;
    height: 20px;
    vertical-align: top;
    display: inline-block;
    margin-top: 0.5px;
    border: 1px solid #0b3454cc;
}
.check_box .form-check-input:checked {
    background-color: #5dae48;
    border-color: #5dae48;
}
.check_box .form-check-input:focus {
    box-shadow: none;
}

.datewrap {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
    height: 45px;
    position: relative;
    overflow: hidden;
}
.daterangePickerList,
.singledaterangePickerList {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
    opacity: 0;
}
.datewrap .arrow {
    background: #f1f1f1 0% 0% no-repeat padding-box;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/*.datewrap .arrow span {background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z'/%3e%3c/svg%3e");font-size: 0;width: 25px;height: 25px;}*/
/* .datewrap .arrow span {
    background: url(../images/arrow.svg) no-repeat center;
    font-size: 0;
    width: 25px;
    height: 25px;
} */
.datewrap .from,
.datewrap .to {
    flex: 1 1;
}
/* .datewrap .form-control {
    height: 100% !important;
    border: 0 !important;
    background: #fff url(../images/calendar.svg) no-repeat 10px center;
} */

/* madhu added */
.form-control[type='date'] {
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat right 10px center;
    text-align: left;
    /* padding-left: 35px; */
    padding-right: 5px;
    position: relative;
}
.form-control[type='date']::-webkit-calendar-picker-indicator,
.form-control[type='date']::-moz-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
}
.form-control.form-date {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: center right 15px;
    background-repeat: no-repeat;
}
.form-control.form-search {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 14px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 34px;
}
/* madhu added */

.form-control.form-linkedin {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.form-control.form-facebook {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.form-control.form-instagram {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}
.form-control.form-twitter {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 13px center;
    padding-left: 48px;
}

.datepicker {
    max-width: 280px;
    width: 100%;
    padding: 0;
}
.datepicker-years {
    overflow: hidden;
    border-radius: 5px;
}
.datepicker .table-condensed {
    width: 100%;
}
.datepicker table tr td span {
    height: auto;
    line-height: 35px;
    border-radius: 25px;
}
.datepicker thead {
    background: #f4faff;
    line-height: 40px;
}
.datepicker table tr td span.active.active {
    background: #5dae48;
}

.prev {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 16px 12px !important;
    font-size: 0;
    width: 50px !important;
}
.opacity-0 {
    opacity: 0;
}
.next {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 16px 12px !important;
    font-size: 0;
    width: 50px !important;
    transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    -o-transform: scaleX(-1);
}
.datepicker .datepicker-switch {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 5px;
}

.form-check.custom-rectbox-radio .form-check-input + label {
    width: 100%;
    height: 45px;
    font-weight: 500;
    border: 1px solid #b9c2cb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    padding: 0 14px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
}
.form-check.custom-rectbox-radio .form-check-input:checked + label {
    background: #5dae48;
    border: 1px solid #5dae48;
    color: #fff;
}
.custom-rectbox-radio {
    padding: 0;
    margin: 0;
    flex: 1 1;
}
.custom-rectbox-radio:not(:last-child) {
    margin-right: 8px;
}
.radio_parent {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
}
.form-check.custom-rectbox-radio .form-check-input + label:before {
    content: '';
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center;
}
.form-check.custom-rectbox-radio .form-check-input + label[for='female']:before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center;
}
.form-check.custom-rectbox-radio .form-check-input:checked + label::before {
    filter: invert(1) brightness(100);
    -webkit-filter: invert(1) brightness(100);
}
.step_header_wrap {
    display: none;
}

.header_container {
    max-width: 1500px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 0px;
    width: 96%;
    flex-wrap: wrap;
}
.ful-header {
    border-bottom: 1px solid #e2e8ef;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
}
.header_container .user_name {
    font-size: 20px;
}
.rightSection_header {
    position: relative;
}
.global_wrap {
    position: relative;
    margin-left: auto;
    height: 100%;
    margin-right: 0px;
}
.global_wrap .global {
    right: 0;
    top: 0px;
    bottom: auto;
}

.scholarship_banner {
    background: transparent linear-gradient(262deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) 0% 0% no-repeat padding-box;
    width: 100%;
    height: 100%;
}
.scholarship_container {
    max-width: 1066px;
    width: 90%;
    margin: auto;
    padding-top: 0px;
}
.scholarship_container h2 {
    font-size: 22px;
    font-weight: 600;
    margin-top: 55px;
}
.scholarship_container h2 span {
    position: relative;
}
.scholarship_container h2 span:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: #5cae48;
    border-radius: 5px;
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
}
.scholarship_detail_list {
    margin: 24px 0 20px 0;
    padding: 0;
    list-style: none;
    display: flex;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    flex-wrap: wrap;
}
.scholarship_detail_list li:not(:last-child) {
    margin-right: 30px;
}
.scholarship_detail_list li {
    position: relative;
    padding-left: 27px;
    margin-bottom: 16px;
}
.scholarship_detail_list li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 20px;
    height: 18px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 0 0;
}
.scholarship_detail_carousel_container {
    max-width: 1066px;
    margin: auto;
    width: 90%;
}
.scholarship_detail_carousel {
    width: 100%;
    padding: 40px 0;
}
.joined_offer_wrap {
    position: relative;
    margin-left: 0;
    margin-bottom: 15px;
    display: flex;
}
.joined_offer_wrap:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    background: #5cae48;
    height: 1px;
}
.joined_label {
    position: relative;
    background: #5cae48 0% 0% no-repeat padding-box;
    border-radius: 16px;
    height: 32px;
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: 400;
    padding: 7px 20px 7px 7px;
    font-size: 14px;
}
.joined_label i {
    width: 20px;
    height: 20px;
    display: inline-block;
    background: #fff;
    border-radius: 50%;
    margin-right: 7px;
    position: relative;
}
.joined_label i:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 5px;
    border-left: 2px solid #5cae48;
    border-bottom: 2px solid #5cae48;
    transform: rotate(-45deg);
    left: 5px;
    top: 7px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

/* madhu added */
.joined_label_noline:before {
    display: none !important;
}
.w-65 {
    width: 65%;
}
/* madhu added */

.offered-univarsity-name {
    font-size: 28px;
    line-height: 32px;
    font-weight: 700;
}
.joined_label.didnt-join {
    background: #0b3454;
}
.joined_label.didnt-join i:before {
    border-left: 2px solid #0b3454;
    border-bottom: 2px solid #0b3454;
}
.joined_offer_wrap.didnt-join:before {
    background: #0b3454;
}

.scholarship_block {
    width: 350px;
}

.card_profiles {
    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%) 0% 0% no-repeat padding-box;
    border-radius: 6px;
    padding: 1px;
    height: auto;
    max-height: initial;
    min-height: initial;
}

/* madhu added */
.card_profiles_pink {
    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) 0% 0% no-repeat padding-box !important;
}
/* madhu added */

.card_profiles:first-child {
    margin: 0 0 10px;
}
.card_profiles .card_profiles_univarsity {
    padding: 19px 19px 13px;
    display: flex;
    flex-direction: column;
    flex: 1 1;
}
.card_profiles .card_profiles_univarsity .card_profiles_name {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: center;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail {
    flex: 1 1;
}
.card_profiles .card_profiles_univarsity .card_profiles_name > a {
    border-radius: 50%;
    overflow: hidden;
    margin-right: 12px;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.card_profiles .card_profiles_univarsity .card_profiles_name a img {
    width: auto;
    height: 100%;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 {
    font-size: 22px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 a {
    border-radius: 0;
    text-decoration: none;
    color: #000;
}
.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 span {
    font-size: 15px;
    font-weight: 500;
    margin-top: 5px;
    color: #0b3454;
}
.carousel-indicators .dot {
    width: 10px;
    height: 10px;
    background: #0b34541a;
    border-radius: 50%;
    margin: 0 4px;
    padding: 0 !important;
    border: 0;
}
.carousel-indicators .dot.active {
    background: #0b3454b3;
}
.scholarship_block > h3 {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 10px;
}
.scholarship_block > h3 span {
    font-size: 18px;
    font-weight: 600;
    display: block;
}
.scholarship_amt_detail {
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 0px 0px 6px 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    -webkit-border-radius: 0px 0px 6px 6px;
    -moz-border-radius: 0px 0px 6px 6px;
    -ms-border-radius: 0px 0px 6px 6px;
    -o-border-radius: 0px 0px 6px 6px;
}
.scholarship_amt {
    font-size: 17px;
    font-weight: 700;
}
.scholarship_label {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
}
.scholarship_label i {
    width: 37px;
    height: 25px;
    display: inline-block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat 0 0;
    margin-right: 10px;
}

.univarsity-block {
    display: flex;
    justify-content: center;
    margin-top: 3px;
}
.univarsity-block .univarsity-block-cover {
    display: flex;
    align-items: center;
    max-width: 255px;
    width: 100%;
}
.card_profiles .card_profiles_univarsity .card_profiles_name a img {
    width: auto;
    height: 100%;
}
.univarsity-block .univarsity-block-cover > a {
    width: 67px;
    height: 67px;
    background: #fff;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid #ddd;
    margin-right: 10px;
}
.univarsity-block .univarsity-block-cover > a img {
    width: auto;
    height: 100%;
}
.univarsity-block .univarsity-block-cover h3 {
    flex: 1 1;
    margin: 0;
}
.univarsity-block .univarsity-block-cover h3 p {
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 3px;
}
.univarsity-block .univarsity-block-cover h3 p a {
    text-decoration: none;
    color: #000;
}
.univarsity-block .univarsity-block-cover h3 .course {
    font-size: 15px;
    font-weight: 500;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    align-items: start;
}
.univarsity-block .univarsity-block-cover h3 .course .img-fluid {
    width: 16px;
    margin-right: 7px;
    margin-top: 1px;
}
.univarsity-block .univarsity-block-cover h3 .course span {
    width: calc(100% - 23px);
}

.scholarship_carousel .owl-dots {
    display: flex;
    justify-content: center;
    margin: 15px;
}
.scholarship_carousel .owl-dots .owl-dot {
    width: 8px;
    height: 8px;
    background: #0b34541a;
    border-radius: 50%;
    margin: 0 4px;
}
.scholarship_carousel .owl-dots .owl-dot.active {
    background: #0b3454b3;
}

#skip_pop .modal-dialog {
    max-width: 600px;
    border-radius: 10px;
}
#skip_pop .modal-content {
    border-radius: 10px;
}
#skip_pop .modal-dialog .modal-body {
    padding: 40px 0 0 50px;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    border-radius: 10px;
    min-height: 300px;
}
.img_pop {
    position: relative;
    z-index: 1;
    float: right;
}
#skip_pop .modal-dialog .modal-body h4 {
    font-size: 22px;
    font-weight: 600;
    position: relative;
    text-transform: uppercase;
}
#skip_pop .modal-dialog .modal-body h4::before {
    content: '';
    position: absolute;
    bottom: -17px;
    width: 50px;
    height: 3px;
    background: #5cae48;
    border-radius: 5px;
}
#skip_pop .modal-dialog .modal-body p {
    font-size: 20px;
    line-height: 28px;
    max-width: 318px;
    margin: 40px 0 0;
    font-weight: 500;
}
#skip_pop .img_pop {
    position: relative;
    z-index: 1;
    float: right;
    margin-top: -30px;
    width: 220px;
    text-align: right;
    display: flex;
    align-items: end;
}
#skip_pop .modal-footer {
    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%) 0% 0% no-repeat padding-box;
    border-radius: 90px 10px 10px 10px;
    opacity: 1;
    display: flex;
    justify-content: start;
    padding-left: 70px;
    border: 0;
    min-height: 90px;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -90px;
    -webkit-border-radius: 90px 10px 10px 10px;
    -moz-border-radius: 90px 10px 10px 10px;
    -ms-border-radius: 90px 10px 10px 10px;
    -o-border-radius: 90px 10px 10px 10px;
}
.btn-goback {
    background: #5cae48;
    border-radius: 31px;
    width: 158px;
    height: 50px;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    text-decoration: none;
}
.btn-goback:hover {
    background: #27970b;
    color: #fff;
}
.btn-later {
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-later:hover {
    color: #f34e65;
}
.btn-skip {
    margin: 15px;
    font-size: 12px;
    -webkit-text-decoration: navajowhite;
            text-decoration: navajowhite;
    font-weight: 500;
    color: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    background: no-repeat;
    border: 0;
}
.btn-skip:hover {
    color: #d42941;
}
.modal-backdrop.show {
    opacity: 0.8;
}

.multiple_benefits_banner {
    background: transparent linear-gradient(262deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%) 0% 0% no-repeat padding-box;
    width: 100%;
    padding-top: 24px;
}
.multiple_benefits_container {
    max-width: 990px;
    margin: auto;
    width: 90%;
}
.multiple_benefits_container h2 {
    font-size: 22px;
    font-weight: 600;
    position: relative;
    margin: 37px 0 25px;
    line-height: 24px;
}
.multiple_benefits_container h2:before {
    content: '';
    position: absolute;
    width: 40px;
    height: 3px;
    background: #5cae48;
    left: 0;
    bottom: -5px;
}
.multiple_benefits_container p {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    max-width: 490px;
}

.multiple_benefits_cards_container {
    max-width: 990px;
    width: 90%;
    margin: auto;
}
.multiple_benefits_cards {
    width: 100%;
    padding: 30px 0;
}
.multiple_benefits_cards_container .card {
    border: 0;
    border-radius: 6px;
    /* overflow: hidden; */
    height: 100%;
}
.multiple_benefits_cards_container .card.network-card {
    background: #fff7f8;
}
.multiple_benefits_cards_container .card.event-card {
    background: #f9f8ff;
}
.multiple_benefits_cards_container .card .card-header {
    padding: 18px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 144px;
}
.multiple_benefits_cards_container .card .card-header .title {
    font-size: 20px;
    line-height: 22px;
    flex: 1 1;
    color: #fff;
}
.multiple_benefits_cards_container .card .card-header .card-img {
    width: auto;
}
.multiple_benefits_cards_container .card.network-card .card-header {
    background: #d42941;
}
.multiple_benefits_cards_container .card.event-card .card-header {
    background: #51499c;
}
.multiple_benefits_cards_container .card .card-body {
    padding: 0;
}
.card .card-body .benefits_toggle {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.card.network-card .card-body .benefits_toggle {
    background: #fce4e7;
}
.card.event-card .card-body .benefits_toggle {
    background: #e8e7f0;
}
.multiple_benefits_cards_container .card .card-body .benefits_toggle .btn {
    width: 100%;
    border-radius: 0;
    min-height: 56px;
    display: flex;
    align-items: center;
    padding: 15px 20px 15px 30px;
    font-weight: 500;
    font-size: 18px;
    color: #000;
    border: 0;
    justify-content: space-between;
}
.benefits_toggle .btn:focus {
    box-shadow: none;
}
.benefits_toggle .toggle {
    width: 15px;
    height: 15px;
    position: relative;
}
.benefits_toggle .toggle::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 15px;
    height: 3px;
    background: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.benefits_toggle .toggle::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 3px;
    height: 15px;
    background: #000;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.benefits_toggle .btn[aria-expanded='true'] .toggle::after {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}
.multiple_benefits_cards_container .card.network-card .card-body .benefits_toggle .btn {
    background: #fce4e7;
}
.benefit-list {
    padding: 0px 30px 26px;
}
.multiple_benefits_cards_container .card .card-body .benefit_form {
    padding: 20px 30px 40px;
}
.benefit-list ul {
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 18px;
    line-height: 22px;
}
.benefit-list ul li {
    padding-left: 25px;
    position: relative;
    margin-bottom: 10px;
}
.benefit-list ul li:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 6px;
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    transform: rotate(-45deg);
    left: 0;
    top: 7px;
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}

.video-btn {
    background: #0b3454 0% 0% no-repeat padding-box;
    border-radius: 25px;
    padding: 9px 20px;
    display: inline-flex;
    text-decoration: none;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    border: 0;
}
.video-btn b {
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
    margin: 0 0 0 7px;
    display: inline-block;
    font-size: 0;
    position: relative;
}
.video-btn b::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 5.5px;
    margin: auto;
    width: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 5px solid #0b3454;
    height: 0;
}
.video-btn:hover {
    color: #fff;
    background: #5bae47;
}
.video-btn:hover b::before {
    border-left: 5px solid #5bae47;
}
.form-label {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    margin: 0 0 4px;
}
.select-option.first-option,
.select-option.second-option {
    position: relative;
}
.select-option.first-option .form-select,
.select-option.second-option .form-select {
    margin-bottom: 20px;
}
.form-check-input:checked ~ .select-option.first-option:after {
    content: '';
    position: absolute;
    bottom: 0;
    border-bottom: 1px solid #00000016;
    width: 208%;
    left: 0;
}
.form-check-input:checked ~ .select-option.second-option:after {
    content: '';
    position: absolute;
    bottom: 0;
    border-bottom: 1px solid #00000016;
    width: 208%;
    right: 0;
}
.benefit_form .form-check {
    margin: 0;
    padding: 0;
}
.benefit_form .form-check .form-check-input[role='switch'] {
    margin-left: 0;
}
.custom_radius_check {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0b3454;
    border-radius: 25px;
    width: 100%;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.custom_radius_check i {
    width: 17px;
    height: 12px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat 0 0;
    filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);
    -webkit-filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);
}
.select-option {
    display: none;
    width: 100%;
    position: relative;
}
.form-check-input:checked ~ .select-option {
    display: inline-block;
}
.select-option .form-select {
    margin-top: 16px;
    border: 1px solid #0b3454;
    border-radius: 6px;
    height: 42px;
}
.form-check-input:checked + .custom_radius_check {
    background: #5cae48;
    border-color: #5cae48;
    color: #fff;
}
.form-check-input:checked + .custom_radius_check i {
    filter: invert(1) brightness(1);
    -webkit-filter: invert(1) brightness(1);
}
.custom_radius_check::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-top: 7px solid transparent;
    width: 0;
    margin: auto;
    top: 85%;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    opacity: 0;
}
.form-check-input:checked + .custom_radius_check::after {
    top: 100%;
    border-top: 7px solid #5cae48;
    opacity: 1;
}
.multiple_benefits_cards_container .action_btns {
    max-width: 100%;
    margin: 0;
}
.bg-drop {
    display: none;
}
footer.footer {
    padding: 15px 0;
    border-top: 1px solid #eee;
    background: #fff;
    position: relative;
    height: auto;
}
.footer-wrap {
    width: 90%;
    margin: auto;
    max-width: 1500px;
}
.powerby {
    display: flex;
    flex-direction: column;
    width: 139px;
}

.pop-dialog {
    max-width: 700px;
    width: 90%;
    margin: auto;
}
.modal.show .modal-dialog .pop-content {
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.pop-footer {
    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%) 0% 0% no-repeat padding-box;
    border-radius: 90px 0px 10px 10px;
    opacity: 1;
    padding: 20px 66px;
    margin-left: 10px;
    -webkit-border-radius: 90px 0px 10px 10px;
    -moz-border-radius: 90px 0px 10px 10px;
    -ms-border-radius: 90px 0px 10px 10px;
    -o-border-radius: 90px 0px 10px 10px;
}
.pop-body {
    min-height: 255px;
    padding: 80px 50px 0;
}
.pop-body .img_pop {
    position: absolute;
    right: -38px;
    bottom: 0;
}
.pop-dialog h4 {
    font-size: 22px;
    font-weight: 600;
    position: relative;
    margin: 0 0 35px;
}
.pop-dialog h4::before {
    content: '';
    position: absolute;
    bottom: -12px;
    width: 50px;
    height: 3px;
    background: #5cae48;
    border-radius: 5px;
}
.pop-body p {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
}
.pop_step {
    padding: 0;
    margin: 40px 0 0;
    list-style: none;
}
.pop_step li {
    padding: 0 0 30px 53px;
    line-height: 22px;
    position: relative;
    display: flex;
    flex-direction: column;
    font-size: 18px;
    font-weight: 500;
}
.pop_step li b {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 7px;
}
.pop_step li .completed_li {
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #5cae48;
    left: 0;
    top: -7px;
    margin: 0 8px;
}
.pop_step li .completed_li:before {
    content: '';
    position: absolute;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    width: 12px;
    height: 7px;
    left: 6px;
    top: 7px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
}
.pop_step li .edit_li {
    position: absolute;
    width: 40px;
    height: 40px;
    background: #0b3454 url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center;
    left: 0;
    top: 0;
    border-radius: 50%;
}
.pop_step li.pop_completed::before {
    content: '';
    position: absolute;
    top: 0;
    left: 19px;
    background: #5cae48;
    width: 2px;
    bottom: 0;
    margin: auto;
}

.mentoring_contact i {
    width: 36px;
    height: 36px;
    background: #27a7df;
    display: flex;
    border-radius: 60px;
    align-items: center;
    justify-content: center;
}
.btn-update {
    border: none;
    padding: 10px 30px;
    background: #5cae48;
    border-radius: 25px;
    color: #ffff;
    text-transform: uppercase;
    font-weight: 500;
    font-weight: 14px;
    transition: all 0.3s ease-in-out;
}
.form-control {
    max-width: 100%;
    height: 45px;
    border: 1px solid #b5c2cb;
    border-radius: 6px;
}
textarea.form-control {
    min-height: 60px;
}
.btn-update:hover {
    background: #43992e;
}
.edit_phone .btn-close {
    font-size: 12px;
}
.btn-cancel {
    background: none;
    border: 0;
    padding: 10px 5px;
    border-radius: 25px;
    margin-left: 10px;
    font-weight: 500;
    color: #828282;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.btn-cancel:hover {
    color: #000;
}

@media (max-width: 1199px) {
    /* .global {bottom: -60px;} */
    .global.show .unlock {
        white-space: normal;
        width: 310px;
    }
    .global.show .unlock .text {
        line-height: 17px;
        font-size: 16px;
    }
    .cta_add {
        flex-direction: column;
    }
    .cta_add .btn-add {
        margin-bottom: 10px;
    }
}

@media (max-width: 991px) {
    .leftPaneBody {
        padding: 0 50px;
    }
    .rightPaneBodyWrap {
        padding: 50px 40px;
    }
    .action_btns button.nextbtn {
        width: 150px;
    }
    .scholarship_block {
        width: 100%;
    }
    .scholarship_carousel .item {
        display: flex;
        justify-content: space-between;
    }
    .scholarship_carousel .item .card_profiles {
        width: 49%;
        display: flex;
        flex-direction: column;
    }
    .item-wrap {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .item-wrap .card_profiles {
        width: 49%;
        margin: 0;
    }
}

@media (min-width: 768px) and (max-width: 992.98px) {
    .form-check-input:checked ~ .select-option.first-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .form-check-input:checked ~ .select-option.second-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        right: -10%;
    }
    .form-check-input:checked ~ .select-option.third-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .select-option.third-option .form-select {
        margin-bottom: 20px;
    }
}

@media (max-width: 767px) {
    .leftPane {
        width: 100%;
    }
    .leftPaneBody {
        max-width: 100%;
        padding: 30px;
    }
    .leftPaneBodyWrap {
        padding: 0px 0 50px;
    }
    .rightPane {
        display: block;
        width: 100%;
        box-shadow: 0px -7px 15px #00000026;
        border-radius: 15px 15px 0px 0px;
        padding: 45px 0px 0px 25px;
        cursor: pointer;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 7;
    }
    .rightPane.basic-information .rightPaneHeaderWrap {
        display: none;
    }
    .rightPaneBodyWrap {
        padding: 0;
        position: static;
    }
    .rightPane.basic-information {
        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%) 0% 0% no-repeat padding-box;
    }
    .rightPane.basic-information.undergraduate-college {
        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) 0% 0% no-repeat padding-box !important;
    }
    .rightPane.basic-information .step_1 {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: end;
    }
    .step_img img {
        width: auto;
        height: 128px;
    }
    .mobile-step-block[aria-expanded='true'] ~ .step_img {
        position: absolute;
        right: 0;
        border: 0;
        opacity: 0.2;
    }
    .textDetail {
        flex: 1 1;
    }
    .action_btns {
        max-width: 90%;
        margin: auto;
        width: 100%;
    }
    .action_btns.social {
        margin: auto;
    }
    .custom-rectbox-radio {
        flex: none;
        width: 130px;
    }
    /* madhu modified */
    .step_header_wrap {
        display: flex;
        -webkit-box-wrap: wrap;
        -moz-box-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-wrap: wrap;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 0;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9;
        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%) 0% 0% no-repeat padding-box;
        box-shadow: 0px -7px 15px #00000026;
        border-radius: 15px 15px 0px 0px;
        padding: 45px 0px 0px 25px;
        cursor: pointer;
        transition: all 0.1s ease-in-out;
        -webkit-transition: all 0.1s ease-in-out;
        -moz-transition: all 0.1s ease-in-out;
        -ms-transition: all 0.1s ease-in-out;
        -o-transition: all 0.1s ease-in-out;
        align-items: end;
    }
    /* madhu modified */

    /* madhu added */
    .step_header_wrap_bg-beige {
        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) 0% 0% no-repeat padding-box !important;
    }
    /* madhu added */

    .step_header_wrap::before,
    .rightPane::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        width: 50px;
        height: 2px;
        background: #727272;
        margin: auto;
        top: 20px;
    }

    .step_header_wrap_img img {
        height: 128px;
    }
    .step_header_wrap_title {
        padding-top: 15px;
        flex: 1 1;
    }
    .steps.showTab > h2 {
        padding: 40px 40px 0;
    }
    .steps_questions {
        /* padding: 0px 40px 40px; */
        margin-top: 30px;
        max-width: 100%;
    }
    .leftPaneHeaderWrap {
        justify-content: center;
        display: flex;
        flex-direction: column;
        height: auto;
    }
    .leftPaneHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 94%;
        margin: auto;
    }
    .leftPaneHeader .user_name {
        display: inline-block;
        font-size: 18px;
    }
    .check_box {
        margin: 20px auto -35px;
        max-width: 680px;
        width: 90%;
    }
    /* madhu modified */
    .step_header_wrap_title > h2 {
        font-size: 18px;
        font-weight: 600;
        margin-right: 15px;
    }
    /* madhu modified */
    .step_header_wrap_link {
        background: transparent;
        border-radius: 27px;
        color: #0b3454;
        text-decoration: none;
        padding: 3px 20px;
        transition: all 0.3s ease-in-out;
        display: inline-block;
        margin-bottom: 18px;
        font-weight: 500;
        border: 2px solid #0b3454;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        -webkit-border-radius: 27px;
        -moz-border-radius: 27px;
        -ms-border-radius: 27px;
        -o-border-radius: 27px;
        display: inline-block;
        margin-top: 16px;
    }
    .step_header_wrap_link span {
        transition: all 0.3s ease-in-out;
    }
    .step_header_wrap_link .less {
        font-size: 0;
    }
    .step_header_wrap_link:hover {
        background: #0b3454;
        color: #fff;
    }
    .step_header_wrap.open .step_header_wrap_link {
        margin-bottom: 20px;
    }

    /* madhu modified */
    .listed_points:not(.show) {
        height: 0;
        overflow: hidden;
    }
    .listed_points ul li {
        font-size: 16px;
        font-size: 16px;
        margin-bottom: 15px;
        line-height: 19px;
    }
    .listed_points ul li:last-child {
        margin-bottom: 0;
    }
    /* madhu modified */

    .mobile-step-block {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 9;
    }
    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .more,
    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .more {
        font-size: 16px;
    }
    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .less,
    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .less {
        font-size: 0;
    }
    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .more,
    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .more {
        font-size: 0px;
    }
    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .less,
    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .less {
        font-size: 16px;
    }
    .step_header_wrap_title .listed_points ul li::before {
        height: 17px;
    }

    .global {
        width: 100%;
        height: 40px;
        position: relative;
        margin-bottom: -26px;
        background: none;
        border-radius: 0;
        margin-top: 25px;
        border-top: 1px solid #e2e8ef;
        bottom: auto;
        right: auto;
    }
    .global .unlock,
    .global.show .unlock {
        width: 100%;
        right: 0;
        bottom: 0;
        border-radius: 0;
        position: static;
        opacity: 1;
    }
    .progress_svg {
        width: 70px;
        height: 70px;
        position: absolute;
        right: 30px;
        top: auto;
        bottom: 0px;
        background: #fff;
        padding: 0;
        border-radius: 50%;
        box-shadow: 0px 0px 10px 0 #d3d3d3;
    }
    .progress_svg .gaugeMeter {
        width: 60px !important;
        height: 60px;
    }
    .progress_svg .gaugeMeter canvas {
        width: 100%;
        height: 100%;
    }
    .progress_svg span {
        line-height: 60px !important;
        font-size: 18px !important;
    }
    .global_wrap {
        width: 100%;
        order: 1;
    }
    .global.show .unlock,
    .global .unlock {
        white-space: normal;
    }
    .global.show .unlock.prize_bg,
    .global .unlock.prize_bg {
        width: auto;
        margin: 0 -2%;
    }
    .global.show .unlock .text,
    .global .unlock .text {
        width: calc(100% - 140px);
    }
    .global .unlock.unlock_blue {
        border-radius: 0 !important;
    }

    /* madhu modified */
    .global .unlock .text {
        font-size: 16px;
        font-weight: 500;
    }
    /* madhu modified */

    .scholarship_carousel .item {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .scholarship_block {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 30px;
        position: relative;
        z-index: 0;
    }
    .scholarship_carousel .item .card_profiles {
        width: 48%;
        margin: 0 0 10px;
        display: flex;
        flex-direction: column;
    }
    .scholarship_amt {
        font-size: 18px;
        font-weight: 700;
    }
    .scholarship_amt_detail {
        padding: 20px 15px;
    }
    /* madhu modified */
    .bg-drop {
        position: fixed;
        left: 0;
        right: 0;
        top: 100%;
        bottom: 0;
        margin: auto;
        background: rgba(0, 0, 0, 0.7);
        z-index: 6;
        transition: all 0.1s ease-in-out;
        display: block;
    }
    /* madhu modified */
    .bg-drop[aria-expanded='true'] {
        top: 0;
    }

    .mobile-step-block[aria-expanded='true'] ~ .step_header_wrap_img {
        position: absolute;
        right: 0;
        border: 0;
        opacity: 0.2;
    }
    .scholarship_detail_carousel {
        padding: 0;
    }
    .leftPaneHeaderWrap .global.nobadge {
        height: 0;
    }
    .leftPaneHeaderWrap .global.nobadge .progress_svg {
        top: -30px;
    }
    .global_wrap .global.nobadge {
        height: auto;
        border: 0;
    }
    .global_wrap .global.nobadge .progress_svg {
        top: -30px;
    }
    footer {
        margin-bottom: 160px;
    }

    .pop-body .img_pop {
        position: static;
        width: 100%;
        text-align: center;
    }
}

@media (max-width: 575px) {
    .ful-header + .main-wrap {
        padding: 30px;
    }
    .leftPaneBody {
        padding: 30px;
    }
    /* madhu added */
    .listed_points {
        margin-top: 10px;
        margin-right: 15px;
    }
    /* madhu added */

    .leftPaneHeader img {
        width: 130px;
    }
    .header_container img {
        width: 130px;
    }
    .step_header_wrap_title {
        padding-top: 0;
    }
    .steps.showTab > h2 {
        padding: 30px 25px 0;
    }
    .steps_questions {
        /* padding: 0px 25px 30px; */
    }
    .action_btns {
        max-width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
    .step_header_wrap_img img {
        height: 100px;
        animation: none;
        -webkit-animation: none;
    }
    .leftPaneHeader .user_name span {
        font-weight: 600;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: top;
    }
    .global .unlock {
        padding: 12px 0;
    }
    .global {
        height: auto;
    }
    .global .unlock {
        height: auto;
    }
    .progress_svg {
        bottom: 10px;
        right: 10px;
    }
    .global_wrap .progress_svg {
        right: 0;
        bottom: 5px;
    }
    .scholarship_carousel .item .card_profiles {
        width: 100%;
        margin: 0 0 10px;
    }
    .scholarship_detail_carousel_container {
        width: 100%;
        overflow: hidden;
    }
    .joined_offer_wrap {
        margin-left: 0;
    }
    .scholarship_block {
        width: 100%;
        margin: auto;
    }
    .scholarship_detail_carousel {
        padding: 0px 0 40px;
    }
    .global_wrap .global {
        top: 0;
        left: 0px;
    }
    .skip_pop .brife {
        flex: 1 1;
    }
    #skip_pop .modal-footer {
        margin: 0;
    }
    #skip_pop .modal-dialog .modal-body {
        padding: 30px 0 0 30px;
    }
    .action_btns .btn-skip {
        margin: 18px 18px 0;
        display: inline-block;
    }
    #skip_pop .img_pop {
        margin-top: 15px;
        text-align: center;
        width: 100%;
        padding-right: 30px;
    }
    .form-check-input:checked ~ .select-option.first-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .form-check-input:checked ~ .select-option.second-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        right: -10%;
    }
    .form-check-input:checked ~ .select-option.third-option::after {
        content: '';
        position: absolute;
        bottom: 0;
        border-bottom: 1px solid #00000016;
        width: 208%;
        left: -10%;
    }
    .select-option.third-option .form-select {
        margin-bottom: 20px;
    }
    .global.nobadge {
        top: auto;
        bottom: auto;
        height: 20px;
        border: 0;
    }
    .global.nobadge .progress_svg {
        top: -23px;
        bottom: auto;
        right: 0;
    }
    .leftPaneHeaderWrap .global.nobadge .progress_svg {
        right: 10px;
        top: -23px;
    }
    .global.show .unlock.prize_bg,
    .global .unlock.prize_bg,
    .global .unlock.laststep_bg {
        height: 50px;
    }
    .unlock.prize_bg .img,
    .unlock.laststep_bg .img {
        margin-bottom: -20px;
    }
    .leftPaneHeaderWrap .progress_svg {
        top: -22px;
    }
    .global_wrap .global.nobadge .progress_svg {
        top: -23px;
    }
    .global_wrap .global.nobadge {
        padding: 10px;
    }
    .global .unlock.green_recom_bg {
        padding: 7px 0;
    }
    .global .unlock.green_recom_bg .text {
        width: calc(100% - 0px);
        padding: 0 20px 0 0;
    }
    .global .unlock.unlock_blue {
        padding: 0;
    }
    .pop-body {
        padding: 30px 30px 0;
    }
    .edit_phone .btn-close {
        font-size: 12px;
        position: absolute;
        top: 0px;
        right: -10px;
    }
    .step_img img {
        height: auto;
        width: 125px;
    }
    .item-wrap .card_profiles {
        width: 100%;
        margin: 0 0 20px;
    }
}

@media (max-width: 400px) {
    .global.show .unlock .text {
        line-height: 16px;
        font-size: 13px;
    }
}

/* madhu added */

.cta_add {
    display: flex;
    font-size: 16px;
    font-weight: 500;
}
.cta_add .form-check label {
    color: #0b3454;
}
.cta_add .form-check input {
    border: 2px solid #0b3454;
    width: 22px;
    height: 22px;
    border-radius: 40px;
    margin-right: 10px;
}
.cta_add .form-check-input:checked {
    background-color: #27970b;
    border: 0 !important;
}
.cta_add .form-check label {
    padding-top: 3px;
    color: #0b3454;
}
.cta_add .btn-add {
    color: #27a7df;
    padding: 0 30px 0 0;
    text-decoration: none;
    display: flex;
    align-items: center;
}
.cta_add .btn-add:hover {
    color: #5cae48;
}
.cta_add .btn-add i {
    margin-right: 10px;
    margin-top: -4px;
}
.cta_add .btn-add i path {
    fill: #5cae48;
    color: #5cae48;
}
.cta_add .btn-add:focus {
    box-shadow: none;
}
.cta_add .btn-add:focus-visible {
    border: none;
    outline: none;
}
.cta_add .btn-add:hover i img {
    filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);
}

.btn-delete {
    padding: 0;
    width: 18px;
    height: 18px;
    position: absolute;
    left: 100%;
    top: 15px;
    opacity: 0.4;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    background: transparent
        url(${___CSS_LOADER_URL_REPLACEMENT_16___})
        0 0 / 18px auto no-repeat;
}
.btn-delete:hover {
    opacity: 1;
}
.form-label ~ .btn-delete {
    top: 45px;
}

.section {
    position: relative;

    padding-right: 20px;
}
.section + .section {
    margin-top: 60px;
}
.section:first-child {
    margin-top: 20px;
}

.section .btn-delete {
    top: 35px;
    bottom: 0;
    margin: auto;
    right: -60px;
}
.section::after {
    content: '';
    position: absolute;
    right: -2px;
    top: 23px;
    bottom: 0;
    width: 1px;
    height: calc(100% - 23px);
    background: #e2e8ef;
}

@media (max-width: 767px) {
    .cta_add {
        display: block;
    }
    .cta_add .btn-add {
        margin-bottom: 10px;
    }
    .section {
        width: calc(100% - 25px);
    }
    .section .btn-delete {
        right: -50px;
    }
}

.font-18 {
    font-size: 18px;
}
.mentoring_contact {
    border: 1px solid #b5c1cb;
    border-radius: 6px;
}
.mentoring_contact p {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
.mentoring_contact p i {
    width: 36px;
    height: 36px;
    background: #27a7df;
    display: flex;
    border-radius: 60px;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}
.mentoring_contact p i img {
    /* height: auto; */
}

.card_achievements {
    text-align: center;
}
.card_achievements .card_profiles_name {
    display: block !important;
}
.card_achievements .card_profiles_univarsity .card_profiles_name > a {
    margin: 0 auto;
    margin-bottom: -47px;
    width: 80px;
    height: 80px;
    position: relative;
    overflow: inherit; /* z-index: 9999; */
}
.card_achievements .scholarship_amt {
    margin: 0 auto;
    margin-top: 30px;
    font-size: 18px;
}
.card_achievements .card_profiles_univarsity .card_profiles_name > a span {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center;
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 20px;
    height: 28px;
    margin-left: -10px;
    bottom: -15px;
}
.card_achievements .card_profiles_univarsity .card_profiles_name > a img {
    border-radius: 50%;
}

/* madhu added */

.profile_picture_qr {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    min-height: 242px;
    border-radius: 10px;
    overflow: hidden;
}
.profile_picture_qr .or {
    width: 2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
.profile_picture_qr .profile_picture_section {
    background: #d42941;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    position: relative;
}
.profile_picture_qr .profile_picture_section:hover {
    background: #bd1f35;
}
.profile_picture_qr .profile_picture_section .block {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    z-index: 1;
}
.profile_picture_qr .qr_section {
    flex: 1 1;
    background: #cffed2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.profile_picture_qr .or span {
    background: #fff;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    position: absolute;
    left: -21px;
    bottom: 0;
    top: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
}
.profile_picture_qr .or::after {
    display: none;
}
.profile_picture_edit {
    border: 2px dashed #ffffff;
    border-radius: 74px;
    width: 145px;
    height: 145px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 0 5px #d42941 inset;
    position: relative;
}
.profile_picture_edit:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    background: #fff;
    border-radius: 50%;
    z-index: 0;
}
.profile_picture_edit img {
    width: 100%;
    position: relative;
}
.profile_picture_edit .image-edit {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 32px;
    height: 32px;
    background: #5cae48;
    border: 3px solid #fff;
    border-radius: 50%;
    transition: all 0.3s ease-in-out;
}
.profile_picture_edit .image-edit:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    height: 12px;
    background: #fff;
    margin: auto;
}
.profile_picture_edit .image-edit:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 12px;
    height: 2px;
    background: #fff;
    margin: auto;
}
.profile_picture_edit .image-edit:hover {
    background: #669f34;
}
.profile_picture_edit_btn {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    text-align: center;
}
.profile_picture_edit_btn label {
    background: #ffe3e3 0% 0% no-repeat padding-box;
    border: 2px solid #ffffff;
    border-radius: 60px;
    font-size: 12px;
    font-weight: 500;
    width: 140px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.profile_picture_section:hover .profile_picture_edit_btn label {
    background: #f7b3b3;
    border: 2px solid#F7B3B3;
}
.profile_picture_edit_btn span {
    font-size: 14px;
    color: #fff;
    line-height: 18px;
}
.profile_picture_qr .qr_section p {
    font-size: 16px;
    margin: 8px 0 0;
    font-weight: 500;
}
.whatapp_text i {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 0 0;
}
.whatapp_text {
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    font-size: 16px;
    font-weight: 600;
    align-items: center;
}
.desclamier {
    font-size: 14px;
    font-style: italic;
    margin: 10px 0 20px;
}

@media (min-width: 768px) and (max-width: 992.98px) {
    .profile_picture_qr {
        flex-direction: column;
    }
    .profile_picture_qr .profile_picture_section {
        padding: 30px;
    }
    .profile_picture_qr .qr_section {
        padding: 30px;
    }
    .profile_picture_qr .or {
        width: 100%;
    }
    .profile_picture_qr .or span {
        left: 0;
        right: 0;
    }
}

@media (max-width: 575px) {
    .profile_picture_qr {
        flex-direction: column;
    }
    .profile_picture_qr .profile_picture_section {
        padding: 30px;
    }
    .profile_picture_qr .qr_section {
        padding: 30px;
    }
    .profile_picture_qr .or {
        width: 100%;
    }
    .profile_picture_qr .or span {
        left: 0;
        right: 0;
    }
    .btn-delete {
        right: -20px;
    }
}

.success_popup {
    max-width: 700px;
}
.success_popup .img_pop {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.success_popup .modal-content {
    min-height: 380px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}
.success_popup .modal-body {
    display: flex;
    align-items: center;
    padding-left: 60px;
}
.success_popup .brife {
    margin-top: -30px;
    max-width: 320px;
}
.success_popup .modal-body h4::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 50px;
    height: 3px;
    background: #5cae48;
    border-radius: 15px;
}
.success_popup .modal-body h4 {
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 20px;
}
.success_popup .modal-footer {
    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%) 0% 0% no-repeat padding-box;
    border-radius: 90px 10px 10px 10px;
    opacity: 1;
    display: flex;
    justify-content: start;
    padding-left: 70px;
    border: 0;
    min-height: 90px;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: -90px;
    -webkit-border-radius: 90px 10px 10px 10px;
    -moz-border-radius: 90px 10px 10px 10px;
    -ms-border-radius: 90px 10px 10px 10px;
    -o-border-radius: 90px 10px 10px 10px;
}
.file {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.file > input[type='file'] {
    display: none;
}
.file > label {
    font-size: 1rem;
    font-weight: 300;
    cursor: pointer;
    outline: 0;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 6px;
    padding-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border: 1px dotted #8499a9;
    min-height: 60px;
    padding: 0;
    font-weight: 400;
    color: #0b3454;
}
.file > label span {
    padding-left: 5px;
    text-decoration: underline;
    color: #27a7df;
    font-weight: 400;
}
.file > label:hover {
    border-color: hsl(0, 0%, 21%);
}
.file > label:active {
    background-color: hsl(0, 0%, 96%);
}
.file > label > i {
    padding-right: 15px;
}
.file--upload > label {
}
.file--upload > label:hover {
    border-color: hsl(204, 86%, 53%);
    background-color: hsl(204, 86%, 96%);
}
.file--upload > label:active {
    background-color: hsl(204, 86%, 91%);
}
.file--uploading > label {
    color: hsl(48, 100%, 67%);
    border-color: hsl(48, 100%, 67%);
}
.file--uploading > label > i {
    animation: pulse 5s infinite;
}
.file--uploading > label:hover {
    border-color: hsl(48, 100%, 67%);
    background-color: hsl(48, 100%, 96%);
}
.file--uploading > label:active {
    background-color: hsl(48, 100%, 91%);
}
form-control.is-valid,
.was-validated .form-control:valid {
    background-image: none;
}
.was-validated .form-select:valid:not([multiple]):not([size]) {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.form-select.is-valid,
.was-validated .form-select:valid {
    color: #000;
}

.question .form-select.customSelect {
    border: 1px solid #b5c2cb;
    border-radius: 6px;
    background-color: #fff;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.customChoose {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 20px #efefef;
    border: 1px solid #b5c1cb;
    border-radius: 6px;
    overflow: hidden;
    position: absolute;
    width: 100%;
    top: 150%;
    z-index: -1;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
}
.question .customChoose .form-control {
    border-width: 0 0 1px 0;
    border-radius: 0;
}
.customChoose.open {
    opacity: 1;
    z-index: 1;
    top: 102%;
}
.customChooseoptions {
    margin: 20px 0 20px;
    padding: 0 15px;
    list-style: none;
    max-height: 160px;
    overflow: auto;
    line-height: 16px;
    scrollbar-width: 4px;
}
/* Works on Chrome, Edge, and Safari */
.customChooseoptions::-webkit-scrollbar {
    width: 4px;
}
.customChooseoptions::-moz-scrollbar {
    width: 4px;
}
.customChooseoptions::-webkit-scrollbar-track {
    background: #eee;
}
.customChooseoptions::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #eee;
}
.customChooseoptions li {
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
}
.customChooseoptions li:hover {
    color: #5cae48;
}
.customChooseoptions li:not(:last-child) {
    margin-bottom: 12px;
}
.customInputSearch + .customChoose.open,
.customInputSearch:focus + .customChoose {
    opacity: 1;
    top: 102%;
    z-index: 1;
}

.input-group-customSelect {
    width: 33.3%;
}
.input-group .customSelect {
    border-radius: 6px 0 0 6px !important;
}
.input-group-customSelect:not(:first-child) label {
    border-radius: 0 !important;
}
.form-select.CurrencySelect.customSelect ~ .customChoose {
    width: 168px;
    border-radius: 6px !important;
}

#login_pop .signup,
#sociallogin,
.bg_side_blue .signup {
    background: #0b3454;
    margin-right: -1px;
    border-radius: 0px 18px 18px 80px;
}
#login_pop .signup h1 {
    font-family: 'Jost', sans-serif;
    color: #fff;
}
#login_pop .signup:before {
    display: none;
}
#login_pop .signup .title {
    position: relative;
}
#login_pop .innercover {
    max-width: 385px;
    width: 90%;
    margin: auto;
    padding: 0 20px;
}
#login_pop .innercover .img {
    display: flex;
    height: auto;
    align-items: flex-end;
    margin-bottom: 37px;
    justify-content: center;
}
.innercover .img img {
    max-width: 200px;
}
.icon.icon-correct::before {
    content: '';
    width: 13px;
    height: 7px;
    border-left: 2px solid #98bbdf;
    border-bottom: 2px solid #98bbdf;
    display: inline-block;
    transform: rotate(-40deg);
    margin: 7px 3px 0 0;
    vertical-align: top;
}
.signup form .form-check-label {
    cursor: pointer;
}
.form-group label[onclick] {
    transition: all 0.3s ease-in-out;
}
.form-group.form-control-email::before {
    width: 16px;
    height: 12px;
    content: '';
    background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat 0 center;
    position: absolute;
    top: 15px;
    bottom: auto;
    margin: auto;
    left: 16px;
    z-index: 2;
}
.form-group.form-control-password::before {
    width: 12px;
    height: 16px;
    content: '';
    background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat 0 center;
    position: absolute;
    top: 15px;
    bottom: auto;
    margin: auto;
    left: 19px;
    z-index: 2;
}
/* .form-group.form-control-mobile::before {
    width: 9px;
    height: 16px;
    content: '';
    background: url(../images/form-cell-phone.svg) no-repeat 0 center;
    position: absolute;
    top: 15px;
    bottom: auto;
    margin: auto;
    left: 16px;
    z-index: 2;
} */
.form-group label[onclick]:hover,
.signup form .form-check-label[for='exampleCheck1']:hover,
.signup a:hover {
    color: #5cae48 !important;
    transition: all 0.3s ease-in-out;
    text-decoration: none;
}
form a:hover {
    text-decoration: none;
}
.form-group label[onclick]:hover {
    color: #5cae48 !important;
}
.signup form .form-check-input:not(#exampleCheck1):checked + label.form-check-label {
    background: #217aff !important;
    border-color: #217aff !important;
    color: #fff;
}
.signup form .form-check-input:checked + label .icon.icon-correct::before {
    border-color: #fff !important;
}
.signup form .form-control {
    min-height: 40px;
    border: none;
    border-radius: 6px;
    font-weight: 500;
    color: #000;
    font-family: 'Jost', sans-serif;
    font-size: 16px;
    z-index: 1;
    position: relative;
}
.signup #existing-user form .form-control {
    padding-left: 50px;
}
.signup #existing-user form .form-control#ShopLoginFormModel_email {
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat 16px center;
}
/* .signup #existing-user form .form-control#ShopLoginFormModel_mobile {
    background: #fff url(../images/form-cell-phone.svg) no-repeat 16px center;
} */
.email-text {
    color: #ffffff99;
}
.signup #existing-user form .form-control#ShopLoginFormModel_password,
.signup #existing-user form .form-control#ShopSignupFormModel_password {
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat 19px center;
}
.signup #existing-user form .form-control#ShopSignupFormModel_first_name,
/* .signup #existing-user form .form-control#ShopSignupFormModel_last_name {
    background: #fff url(../images/form-user.svg) no-repeat 19px center;
} */
/* .signup #existing-user form .form-control#ShopSignupFormModel_present_class {
    background: #fff url(../images/form-measure.svg) no-repeat 16px center;
} */
/* .signup #existing-user form .form-control#ShopSignupFormModel_board_id {
    background: #fff url(../images/form-open-book.svg) no-repeat 16px center;
} */
/* .signup #existing-user form .form-control#ShopSignupFormModel_country_code {
    background: #fff url(../images/form-globe.svg) no-repeat 16px center;
} */
/* .signup #existing-user form .form-control#ShopSignupFormModel_mobile_number {
    background: #fff url(../images/form-cell-phone.svg) no-repeat 16px center;
} */
.signup form .form-group {
    position: relative;
}
.signup form .form-group .viewpassword {
    position: absolute;
    right: 15px;
    bottom: auto;
    top: 14px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-content: center;
    z-index: 2;
}
.signup form .form-control + .viewpassword::before {
    content: '';
    width: 0%;
    height: 2px;
    background: #022d6d;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: rotate(45deg);
    transition: all 0.3s ease-in-out;
}
.signup form .form-control[type='text'] + .viewpassword::before {
    width: 100%;
    transition: all 0.3s ease-in-out;
}
.signup form .form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid rgba(0, 0, 0, 0.25);
    appearance: none;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
}
.signup form .form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
}
.signup form .form-check-input[type='checkbox'] {
    border-radius: 0.25em;
}
.signup form .form-check-input:checked {
    background-color: #7fb507;
    border-color: #7fb507;
}
.signup form .form-check-input:checked[type='checkbox'] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.signup .owl-dots .owl-dot {
    box-shadow: 0 0 0 0;
}
.signup .owl-theme .owl-dots .owl-dot.active span,
.signup .owl-theme .owl-dots .owl-dot:hover span {
    background: #585858;
    opacity: 0.8;
}
.login-footer {
    margin: 50px 0;
}
.login-footer p {
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    position: relative;
}
.login-footer p::after {
    background: #c5c5c5;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 7px;
    margin: auto;
    content: '';
    left: 0;
    right: 0;
}
.login-footer p b {
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    position: relative;
    z-index: 2;
    background: #fff;
    padding-right: 15px;
}
.login-footer > span {
    color: #060606;
    font-size: 12px;
    line-height: 16px;
    opacity: 0.6;
}
.signup .or {
    margin: 0 0 20px;
    text-align: center;
    display: inline-block;
    width: 100%;
    font-size: 18px;
    line-height: 22px;
    color: #fff;
    position: relative;
}
#existing-user.active ~ div .btn-signin {
    display: none;
}
.input-otp {
    max-width: 60px;
    width: 100%;
    outline: none;
    box-shadow: none;
}
#new-user.active ~ div .btn-signup {
    display: none;
}
#new-user .nav-pills .nav-link {
    background: #fff;
    width: 100%;
}
#new-user .nav-pills .nav-link.active {
    background: #217aff;
}
#new-user ul.nav-pills li {
    width: 30%;
}
#new-user .nav-pills .nav-link.active .icon.icon-correct::before {
    border-color: #fff !important;
}
#pills-others.active + div {
    display: none;
}
.or::after {
    background: #38566e;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 7px;
    margin: auto;
    content: '';
    left: 0;
    right: 0;
    max-width: 463px;
}
.signup .or b {
    font-weight: 400;
    font-family: 'Jost', sans-serif;
    background: #0b3454;
    position: relative;
    z-index: 2;
    padding: 0 10px;
}
.sociallnks {
    text-align: center;
}
.sociallnks p {
    font-size: 14px;
    line-height: 17px;
    color: #fff;
    font-family: 'Jost', sans-serif;
    margin: 0;
    font-weight: 400;
}
.sociallnks p a {
    color: #a2e609;
    font-weight: 500;
}
.sociallnks p a:hover {
    text-decoration: none;
}
.sociallinks ul {
    list-style: none;
}
.sociallnks ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    -webkit-box-wrap: wrap;
    -moz-box-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-wrap: wrap;
    flex-wrap: wrap;
    justify-content: center;
}
.sociallnks ul li a {
    background: #ffffff;
    box-shadow: 0px 5px 10px #0000001a;
    border-radius: 18px;
    width: 100%;
    display: flex;
    height: 36px;
    justify-content: center;
    align-items: center;
}
.sociallnks ul li {
    width: 100px;
    margin: 20px 10px;
}
.signup form .gendar-radio-button + label {
    float: left;
    padding: 0.5em 1em;
    cursor: pointer;
    border: 1px solid #28608f;
    margin-right: -1px;
    color: #000;
    background-color: #ffffff;
    width: 100%;
    border-radius: 6px;
    min-height: 40px;
    display: flex;
    align-items: center;
    border: none;
}
.signup form .error .error-valid-text {
    color: #fff !important;
    margin-top: 3px;
}
.signup form .error .form-control {
    background-color: #f7d7d7 !important;
    border: 1px solid #fd7373;
}
/* .signup form .gendar-radio-button + label[for='maleBtn'] {
    background: #fff url(../images/form-male_blue.svg) no-repeat 16px center;
    padding-left: 50px;
} */
/* .signup form .gendar-radio-button + label[for='femaleBtn'] {
    background: #fff url(../images/form-female_blue.svg) no-repeat 16px center;
    padding-left: 50px;
} */
/* .signup form .gendar-radio-button:checked + label[for='maleBtn'] {
    background: #1074e9 url(../images/form-male_white.svg) no-repeat 16px center;
} */
/* .signup form .gendar-radio-button:checked + label[for='femaleBtn'] {
    background: #1074e9 url(../images/form-female_white.svg) no-repeat 16px center;
} */
.signup form .gendar-radio-button + label:first-of-type {
}
.signup form .gendar-radio-button + label:last-of-type {
}
.signup form .gendar-radio-button:checked + label {
    background-color: #1074e9;
    color: #fff;
}
.btn-access {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
#new-user .progress {
    height: 6px;
    background: #051c3e;
}
#new-user a#but_add {
    cursor: pointer;
}
#myloginTab {
    display: flex;
}
#myloginTab li {
    flex: 2 1;
}
#myloginTab li button {
    width: 100%;
    border: 0;
    border-radius: 0;
    line-height: 70px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Jost', sans-serif;
    background: #04243c;
    color: rgba(255, 255, 255, 0.5);
}
#myloginTab li button.active {
    background: #0b3454;
    color: #fff;
}
.daterangepicker .calendar-table th {
    background-image: none;
}
.daterangepicker .calendar-table .next span {
    transform: rotate(130deg);
    -webkit-transform: rotate(130deg);
}

.page_loader {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
    z-index: 5;
}
.page_loader .sr-only {
    font-size: 0;
}
.page_loader .spinner-border {
    border-color: #fff #fff #fff transparent;
    width: 100px;
    height: 100px;
    border-width: 10px;
}

.css-b62m3t-container .css-t3ipsp-control,
.css-b62m3t-container,
.css-13cymwt-control {
    height: 43px !important;
    border: 0 !important;
}
div.css-9kqgro-control,
div.css-xpesdl-control,
div.css-9kqgro-control {
    min-height: 38px !important;
    margin-top: 1px;
    margin-right: 1px;
}
div.css-1fdsijx-ValueContainer {
    padding: 0;
}
div.css-3w2yfm-ValueContainer {
    display: inline-block;
    overflow: hidden;
    padding-left: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow-x: auto;
    scrollbar-width: thin;
}

div.css-3w2yfm-ValueContainer::-webkit-scrollbar {
    height: 3px;
}
div.css-3w2yfm-ValueContainer::-moz-scrollbar {
    height: 3px;
}
div.css-3w2yfm-ValueContainer::-webkit-scrollbar-track {
    background: #ccc;
}
div.css-3w2yfm-ValueContainer::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 20px;
    border: 2px solid #666;
}
div.css-1p3m7a8-multiValue {
    display: inline-flex;
}
.delete-sticky {
    position: sticky;
    top: 147px;
    right: 0;
    text-align: right;
    cursor: pointer;
}
.blue-tick {
    color: blue;
}
.header_container img {
    height: 100%;
    width: auto;
    max-height: 42px;
}

.school_logo {
    max-height: 70px;
}

.alumni-welcome-image-logo {
    height: 60px;
    border-radius: 50%;
    width: 60px;
}

.btn-blue {
    background: #0b3c54;
    border-radius: 27px;
    height: 40px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    border: 0;
}

.relevantAlumniMatch .btn-complete-now {
    border: 1px solid #d42941;
    border-radius: 25px;
    width: 160px;
    height: 40px;
    background: #fff;
    color: #000;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    margin-right: 23px;
    transition: all 0.3s ease-in-out;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
}
.sucess-message {
    color: white !important;
}
.error-message {
    color: red !important;
}

.mention-dropdown {
    border: 1px solid #ccc;
    background-color: white;
    z-index: 1000;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.mention-option {
    padding: 8px 12px;
    cursor: pointer;
}

.mention-option:hover {
    background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/alumni.css"],"names":[],"mappings":"AACA;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,+BAA+B;AACnC;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IAKI,SAAO;AACX;AACA;;IAEI,2HAA2H;IAC3H,mBAAmB,EAAE,iBAAiB,EACwC,aAAa,EACV,4BAA4B;IAC7G,6EAA6E,EAAE,qDAAqD;IACpI,mHAAmH,EAAE,UAAU;AACnI;AACA;;IAEI,2HAA2H;IAC3H,mBAAmB,EAAE,iBAAiB,EACwC,aAAa,EACV,4BAA4B;IAC7G,6EAA6E,EAAE,qDAAqD;IACpI,mHAAmH,EAAE,UAAU;AACnI;;AAEA,gBAAgB;AAChB;IACI,gHAAgH;AACpH;AACA,gBAAgB;AAChB;IACI,6HAA6H;AACjI;AACA;IACI,gHAAgH;AACpH;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,2CAA2C;AAC/C;AACA;IACI,kCAAkC;IAClC,2CAA2C;AAC/C;AACA;IACI,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,+GAA+G;IAC/G,sBAAsB;AAC1B;AACA;IACI,+GAA+G;IAC/G,4BAA4B;AAChC;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,+GAA+G;AACnH;AACA;IACI,gHAAgH;AACpH;;AAEA,gBAAgB;;AAEhB;IACI,gBAAgB;AACpB;AACA;IAKI,SAAO;IASP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IAKI,SAAO;AACX;;AAEA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,gCAAgC;IAKhC,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IAKf,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,SAAO;AACX;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IAKI,SAAO;AACX;AACA;IAKI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,oGAAoG;IACpG,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,YAAY;IACZ,UAAU;IACV,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,WAAW;IACX,gCAAgC;IAChC,UAAU;IACV,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,+GAA+G;IAC/G,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IAKb,aAAa;IACb,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IAKI,SAAO;AACX;AACA;IACI,gBAAgB;IAChB,gCAAgC;IAKhC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAKlB,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;AACA,iJAAiJ;AACjJ;IACI,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA,mBAAmB;AACnB;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;AACA,mBAAmB;;AAEnB,gBAAgB;AAChB;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA,gBAAgB;;AAEhB;IACI,mBAAmB;AACvB;;AAEA;IAKI,aAAa;AACjB;AACA;IAKI,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,gBAAgB;AACpB;AACA,mBAAmB;AACnB;IACI;iBACa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,cAAc;AAClB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAKlB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA,mBAAmB;AACnB;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA,mBAAmB;;AAEnB;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IAKZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IAKd,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,4BAA4B;IAC5B,cAAc;IACd,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;;IAEI,4DAA6K;IAC7K,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,4DAA6K;IAC7K,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,oCAAoC;IACpC,WAAW;IACX,4CAA4C;AAChD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,sCAAsC;IACtC,UAAU;IACV,8CAA8C;AAClD;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ;AACA;IACI,0BAA0B;IAC1B,mDAAmD;IACnD,2DAA2D;AAC/D;;AAEA;IACI;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;IACA;QACI,4BAA4B;QAC5B,oCAAoC;QACpC,iCAAiC;QACjC,gCAAgC;QAChC,+BAA+B;IACnC;IACA;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,+BAA+B;QAC/B,8BAA8B;QAC9B,6BAA6B;IACjC;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;;AAEA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IACI,+CAA+C;IAC/C,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,obAAob;AACpb;;;;;GAKG;AACH;;IAEI,SAAO;AACX;AACA;;;;GAIG;;AAEH,gBAAgB;AAChB;IACI,oFAAwE;IACxE,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,yDAA6C;IAC7C,sCAAsC;IACtC,4BAA4B;AAChC;AACA;IACI,yDAA2C;IAC3C,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA,gBAAgB;;AAEhB;IACI,yDAA6C;IAC7C,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,yDAA6C;IAC7C,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,yDAA8C;IAC9C,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,yDAA4C;IAC5C,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,yDAA0V;IAC1V,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,yDAA2V;IAC3V,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;IACrC,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,UAAU;IACV,SAAS;IAKT,SAAO;AACX;AACA;IACI,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,qEAAyD;AAC7D;AACA;IACI,qEAA2D;AAC/D;AACA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU;IACV,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,QAAQ;IACR,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kHAAkH;IAClH,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kEAAiD;AACrD;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;IACI,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA,gBAAgB;;AAEhB;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qGAAqG;IACrG,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,gHAAgH;AACpH;AACA,gBAAgB;;AAEhB;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IAKvB,aAAa;IACb,sBAAsB;IAKtB,SAAO;AACX;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IAKZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,+CAA+C;IAC/C,8BAA8B;IAK9B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kEAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAO;IACP,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAKhB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;IAKtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,kHAAkH;IAClH,kCAAkC;IAClC,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,eAAe;IACf,oCAA4B;YAA5B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kHAAkH;IAClH,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,OAAO;IACP,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAO;IACP,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,WAAW;IACX,OAAO;AACX;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,kCAAkC;IAClC,WAAW;IACX,QAAQ;AACZ;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kEAAuD;IACvD,4FAA4F;IAC5F,oGAAoG;AACxG;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,UAAU;AACd;AACA;IACI,SAAS;IACT,6BAA6B;IAC7B,UAAU;AACd;AACA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;AAChB;AACA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kHAAkH;IAClH,iCAAiC;IACjC,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6EAAiE;IACjE,OAAO;IACP,MAAM;IACN,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,aAAa;QACb,sBAAsB;IAC1B;IACA;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,WAAW;QACX,mCAAmC;QACnC,gCAAgC;QAChC,0BAA0B;QAC1B,eAAe;QACf,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,kHAAkH;IACtH;IACA;QACI,6HAA6H;IACjI;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;IAChB;IACA;QACI,SAAO;IACX;IACA;QACI,cAAc;QACd,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA,mBAAmB;IACnB;QAKI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,8BAA8B;QAC9B,SAAS;QACT,eAAe;QACf,OAAO;QACP,QAAQ;QACR,SAAS;QACT,UAAU;QACV,kHAAkH;QAClH,mCAAmC;QACnC,gCAAgC;QAChC,0BAA0B;QAC1B,eAAe;QACf,gCAAgC;QAChC,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;QACnC,gBAAgB;IACpB;IACA,mBAAmB;;IAEnB,gBAAgB;IAChB;QACI,6HAA6H;IACjI;IACA,gBAAgB;;IAEhB;;QAEI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,WAAW;QACX,WAAW;QACX,mBAAmB;QACnB,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,SAAO;IACX;IACA;QACI,oBAAoB;IACxB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,aAAa;QACb,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,UAAU;QACV,YAAY;IAChB;IACA;QACI,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,UAAU;IACd;IACA,mBAAmB;IACnB;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;IACA,mBAAmB;IACnB;QACI,uBAAuB;QACvB,mBAAmB;QACnB,cAAc;QACd,qBAAqB;QACrB,iBAAiB;QACjB,gCAAgC;QAChC,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;QAChB,yBAAyB;QACzB,wCAAwC;QACxC,qCAAqC;QACrC,oCAAoC;QACpC,mCAAmC;QACnC,2BAA2B;QAC3B,wBAAwB;QACxB,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,gBAAgB;IACpB;IACA;QACI,gCAAgC;IACpC;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;;IAEA,mBAAmB;IACnB;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA,mBAAmB;;IAEnB;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,MAAM;QACN,SAAS;QACT,UAAU;IACd;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,YAAY;IAChB;IACA;;QAEI,cAAc;IAClB;IACA;;QAEI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,6BAA6B;QAC7B,YAAY;QACZ,WAAW;IACf;IACA;;QAEI,WAAW;QACX,QAAQ;QACR,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,kBAAkB;QAClB,kCAAkC;IACtC;IACA;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;IACA;QACI,WAAW;QACX,QAAQ;IACZ;IACA;;QAEI,mBAAmB;IACvB;IACA;;QAEI,WAAW;QACX,aAAa;IACjB;IACA;;QAEI,yBAAyB;IAC7B;IACA;QACI,2BAA2B;IAC/B;;IAEA,mBAAmB;IACnB;QACI,eAAe;QACf,gBAAgB;IACpB;IACA,mBAAmB;;IAEnB;QACI,aAAa;QACb,eAAe;QACf,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA,mBAAmB;IACnB;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,SAAS;QACT,SAAS;QACT,YAAY;QACZ,8BAA8B;QAC9B,UAAU;QACV,gCAAgC;QAChC,cAAc;IAClB;IACA,mBAAmB;IACnB;QACI,MAAM;IACV;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,YAAY;QACZ,SAAS;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA,gBAAgB;IAChB;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA,gBAAgB;;IAEhB;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;IAClB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,cAAc;QACd,aAAa;IACjB;IACA;QACI,aAAa;QACb,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,QAAQ;QACR,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,MAAM;QACN,SAAS;IACb;IACA;QACI,SAAO;IACX;IACA;QACI,SAAS;IACb;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,WAAW;QACX,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,SAAS;IACb;IACA;QACI,UAAU;QACV,YAAY;QACZ,QAAQ;IACZ;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;;;QAGI,YAAY;IAChB;IACA;;QAEI,oBAAoB;IACxB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,UAAU;IACd;IACA;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,6FAA6F;AACjG;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC;;iCAE6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;;IAElB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAE,mBAAmB;AAC1C;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qEAAqD;IACrD,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA,gBAAgB;;AAEhB;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,eAAe;IACf,UAAU;AACd;AACA;IACI,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,MAAM;IACN,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kEAAqD;AACzD;AACA;IAKI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,OAAO;QACP,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,OAAO;QACP,QAAQ;IACZ;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kHAAkH;IAClH,kCAAkC;IAClC,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,mBAAmB;AACvB;AACA;AACA;AACA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;;IAEI,sBAAsB;AAC1B;AACA;IACI,0DAAiP;AACrP;AACA;;IAEI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,+CAA+C;IAC/C,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,UAAU;IACV,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;AACA,sCAAsC;AACtC;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,UAAU;IACV,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;;;IAGI,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;AACrC;AACA;IACI,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IAKI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,uEAA4D;IAC5D,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,uEAA2D;IAC3D,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,UAAU;AACd;AACA;;;;;;;;;;;GAWG;AACH;;;IAGI,yBAAyB;IAKzB,gCAAgC;IAChC,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,WAAW;AACf;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,+EAAoE;AACxE;AACA;;GAEG;AACH;IACI,gBAAgB;AACpB;AACA;;IAEI,+EAAmE;AACvE;AACA;;;;;;;;;;;;;;;;;IAiBI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,WAAW;IACX,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,wBAAwB;IAKxB,gCAAgC;AACpC;AACA;IACI,WAAW;IAKX,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,qCAAqC;IAGrC,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB;oCACgC;AACpC;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,0DAA+O;AACnP;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,+BAA+B;IAC/B,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IAKT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;;;GAGG;AACH;;;GAGG;AACH;;GAEG;AACH;;GAEG;AACH;AACA;AACA;AACA;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAO;AACX;AACA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;IAGI,uBAAuB;IACvB,oBAAoB;AACxB;AACA;;;IAGI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IAKf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Jost:wght@100;200;300;400;500;600;700&display=swap');\n* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    font-family: 'Jost', sans-serif;\n}\nbody {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n.flex-1 {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.bg-skyblue-gradient,\n.basic-information {\n    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f3f9ff+0,f7fbff+44,f0f7ff+100 */\n    background: #f3f9ff; /* Old browsers */\n    background: -moz-linear-gradient(top, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(top, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to bottom, #f3f9ff 0%, #f7fbff 44%, #f0f7ff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3f9ff', endColorstr='#f0f7ff',GradientType=0 ); /* IE6-9 */\n}\n.bg-beige-gradient,\n.undergraduate-college {\n    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f3f9ff+0,f7fbff+44,f0f7ff+100 */\n    background: #fffbf2; /* Old browsers */\n    background: -moz-linear-gradient(top, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(top, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to bottom, #fffbf2 0%, #fef8ea 44%, #fef7e7 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#FFFBF2', endColorstr='#FEF7E7',GradientType=0 ); /* IE6-9 */\n}\n\n/* madhu added */\n.bg-purple-gradient {\n    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%) 0% 0% no-repeat padding-box !important;\n}\n/* madhu added */\n.bg-green-gradient {\n    background: transparent linear-gradient(211deg, #fefffd 0%, #ebffe6 76%, #c6ebbe 100%) 0% 0% no-repeat padding-box !important;\n}\n.bg-pink-gradient {\n    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) 0% 0% no-repeat padding-box !important;\n}\n\n.rightPane.basic-information .rightPaneHeaderWrap {\n    background: #f3f9ff;\n}\n.rightPane.undergraduate-college .rightPaneHeaderWrap {\n    background: #fffbf2;\n}\n.rightPane.bg-purple-gradient .rightPaneHeaderWrap {\n    background: #efedff;\n}\n.bg-green-gradient .rightPaneHeaderWrap {\n    background: transparent !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.5);\n}\n.bg-green-gradient .rightPaneHeaderWrap {\n    background: transparent !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.bg-pink-gradient .rightPaneHeaderWrap {\n    background: transparent !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.green_recom_bg {\n    background: transparent linear-gradient(95deg, #5cae48 0%, #27a7df 100%) 0% 0% no-repeat padding-box !important;\n    right: 50px !important;\n}\n.green_recom_bg_left {\n    background: transparent linear-gradient(95deg, #5cae48 0%, #27a7df 100%) 0% 0% no-repeat padding-box !important;\n    /* right: 50px !important; */\n}\n.bg_transparant {\n    background: transparent !important;\n}\n\n.prize_bg {\n    background: transparent linear-gradient(94deg, #51499c 0%, #d42941 100%) 0% 0% no-repeat padding-box !important;\n}\n.laststep_bg {\n    background: transparent linear-gradient(101deg, #51499c 0%, #27a7df 100%) 0% 0% no-repeat padding-box !important;\n}\n\n/* madhu added */\n\n.user_name span {\n    font-weight: 600;\n}\n.main-wrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background-color: #fff;\n}\n.main-wrap > .row {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.leftPane {\n    width: 57.82%;\n}\n.leftPaneHeaderWrap {\n    padding: 25px 0px;\n    border-bottom: 1px solid #e2e8ef;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: end;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 3;\n    height: 93px;\n}\n.leftPaneHeader {\n    max-width: 900px;\n    width: 96%;\n}\n.leftPaneHeader .user_name {\n    display: none;\n}\n.leftPaneHeader img {\n    height: 100%;\n    width: auto;\n}\n.leftPaneBodyWrap {\n    padding: 50px 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: end;\n}\n.leftPaneBody {\n    padding: 0 100px;\n    max-width: 890px;\n    width: 100%;\n}\n\n.leftPaneWrap {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n.leftPaneWrap .leftPaneBodyWrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.leftPaneBody .qs_body {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n.leftPaneBody .qs_body .step {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.leftPaneBody .qs_body .steps {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.leftPaneBody .qs_body .form-check-inline {\n    min-height: 45px;\n    display: inline-flex;\n    align-items: center;\n    margin-top: 2px;\n}\n.leftPaneBody .qs_body .form-check-inline input {\n    margin-right: 5px;\n    width: 20px;\n    height: 20px;\n    transition: all 0.3s ease-in-out;\n}\n.leftPaneBody .qs_body .form-check-inline .form-check-label {\n    margin-top: 2px;\n}\n.progress_svg {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    z-index: 2;\n    background: white;\n    border-radius: 50%;\n}\n.global {\n    position: absolute;\n    background: white;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    bottom: -50px;\n    right: -50px;\n}\n.unlock {\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    background: transparent linear-gradient(96deg, #f05a2a 0%, #f8b018 100%) 0% 0% no-repeat padding-box;\n    border-radius: 30px 0px 0px 30px;\n    height: 40px;\n    right: 20px;\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    z-index: 1;\n    -webkit-border-radius: 30px 0px 0px 30px;\n    -moz-border-radius: 30px 0px 0px 30px;\n    -ms-border-radius: 30px 0px 0px 30px;\n    -o-border-radius: 30px 0px 0px 30px;\n    width: auto;\n    transition: all 0.5s ease-in-out;\n    opacity: 0;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.unlock_blue {\n    background: transparent linear-gradient(95deg, #27a7df 0%, #51499c 100%) 0% 0% no-repeat padding-box !important;\n    border-radius: 30px 0px 0px 30px !important;\n}\n\n.unlock .img {\n    margin: 0 10px 0 5px;\n}\n.unlock .img img {\n    width: 30px;\n    height: 30px;\n}\n.unlock.prize_bg .img,\n.unlock.laststep_bg .img {\n    display: flex;\n    align-items: end;\n    height: 100%;\n}\n.unlock.unlock_blue .img {\n    margin: 0 5px 10px -3px;\n}\n.unlock.green_recom_bg .img {\n    display: flex;\n    align-items: end;\n    height: 100%;\n    padding: 0 0 5px 8px;\n}\n.unlock.prize_bg .img img {\n    width: 62px;\n    height: auto;\n}\n.unlock.laststep_bg .img img {\n    width: 48px;\n    height: auto;\n}\n.unlock.green_recom_bg .img img {\n    width: 43px;\n    height: auto;\n}\n.unlock.unlock_blue .img img {\n    width: 57px;\n    height: auto;\n}\n\n.unlock.prize_bg .img {\n    display: flex;\n    align-items: end;\n    height: 100%;\n}\n.unlock.prize_bg .img img {\n    width: 62px;\n    height: auto;\n}\n.unlock .text {\n    line-height: 18px;\n    color: #fff;\n    padding-right: 30px;\n    font-size: 18px;\n    font-weight: 400;\n    width: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.progress_svg span {\n    position: absolute;\n    left: auto;\n    right: auto;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    font-size: 25px !important;\n    font-weight: 600;\n    color: #000 !important;\n    line-height: 90px !important;\n}\n.progress_svg span::after {\n    content: '%';\n    font-size: 18px !important;\n}\n.progress_svg .gaugeMeter {\n    width: 90px;\n    height: 90px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.global.show .unlock .text {\n    width: auto;\n}\n.global.show .unlock {\n    right: 80px;\n    opacity: 1;\n}\n\n.rightPane {\n    width: 42.18%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.rightPaneWrap {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.rightPaneHeaderWrap {\n    min-height: 93px;\n    border-bottom: 1px solid #e4e8ef;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n\n.rightPaneHeader {\n    max-width: 600px;\n    width: 96%;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n}\n.rightPaneBodyWrap {\n    padding: 50px 60px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    position: sticky;\n    top: 93px;\n}\n.rightPaneBody {\n    padding: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.step {\n    display: none;\n    flex-direction: column;\n}\n.step .stepHeader {\n    width: 100%;\n    margin: 0;\n    font-size: 22px;\n    font-weight: 600;\n    text-transform: uppercase;\n    position: relative;\n    padding: 0;\n}\n/* .step .stepHeader::before {content: '';position: absolute;left: 0;bottom: 0;width: 44px;height: 4px;background: #5cae48;border-radius: 5px;} */\n.step_img {\n    margin: 0;\n}\n.step_img img {\n    width: inherit;\n}\n.step p {\n    width: 100%;\n    margin: 0;\n    font-size: 18px;\n}\n\n.listed_points {\n    margin-top: 20px;\n}\n.step_header_wrap_link {\n    display: none;\n}\n.listed_points ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.listed_points ul li {\n    position: relative;\n    margin-bottom: 15px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 22px;\n    padding: 0 0 0 10px;\n}\n/* madhu modified */\n.listed_points ul li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0px;\n    width: 3px;\n    height: 20px;\n    background: #27a7df;\n    border-radius: 15px;\n}\n/* madhu modified */\n\n/* madhu added */\n.listed_points ul.beige-line li:before {\n    background: #f8b018 !important;\n}\n.listed_points ul.purple-line li:before {\n    background: #51499c !important;\n}\n.listed_points ul.orange-line li:before {\n    background: #f05a2a !important;\n}\n.listed_points ul.green-line li:before {\n    background: #5cae48 !important;\n}\n.listed_points ul.pink-line li:before {\n    background: #ee4c61 !important;\n}\n/* madhu added */\n\n.undergraduate-college .listed_points ul li::before {\n    background: #f8b018;\n}\n\n.rightPane.basic-information .step_1 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n.rightPane.undergraduate-college .step_2 {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n}\n\n.steps {\n    /*height: 0px;opacity: 0;overflow: hidden;*/\n    transition: all 1s ease-in-out;\n    -webkit-transition: all 1s ease-in-out;\n    -moz-transition: all 1s ease-in-out;\n    -ms-transition: all 1s ease-in-out;\n    -o-transition: all 1s ease-in-out;\n}\n.steps.showTab {\n    height: auto;\n    opacity: 1;\n}\n.action_btns #viewcareersbtn {\n    display: none;\n}\n/* madhu modified */\n.steps_questions {\n    padding: 0 0 0 0px;\n    margin-top: 0px;\n    /* left: -50px; */\n    position: relative;\n    /* opacity: 0; */\n    transition: all 1s ease-in-out;\n    -webkit-transition: all 1s ease-in-out;\n    -moz-transition: all 1s ease-in-out;\n    -ms-transition: all 1s ease-in-out;\n    -o-transition: all 1s ease-in-out;\n    max-width: 640px;\n}\n/* madhu modified */\n.steps.showTab .steps_questions {\n    /* left: 0px;\n    opacity: 1; */\n}\n.steps_questions h2 {\n    font-size: 22px;\n    font-weight: 800;\n    /* margin-left: 50px; */\n    /* opacity: 0; */\n    transition: all 0.3s ease-in-out;\n}\n.steps.showTab h2 {\n    margin-left: 0px;\n    opacity: 1;\n}\n.steps_questions h2 span {\n    position: relative;\n}\n.steps_questions h2 span:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 0;\n    height: 2px;\n    background: #5dae48;\n    border-radius: 5px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.steps_questions h2 span:before {\n    width: 100%;\n}\n.steps.showTab h2 {\n    opacity: 1;\n    margin-left: 0;\n}\n.question_wrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.question_number {\n    margin-right: 10px;\n    display: none;\n}\n.question_number span {\n    width: 33px;\n    height: 33px;\n    border: 2px solid #dddddd;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 500;\n    color: #000;\n}\n.question .form-label {\n    font-size: 18px;\n    font-weight: 500;\n    margin-top: 3px;\n    margin-bottom: 3px;\n}\n.question .form-label .info {\n    width: 20px;\n    height: 20px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #656565;\n    border: 1px solid #656565;\n    border-radius: 50%;\n    font-style: italic;\n    font-family: initial;\n    font-weight: 600;\n    font-size: 12px;\n    color: #fff;\n}\n.question {\n    width: 100%;\n    position: relative;\n}\n/* madhu modified */\n.main-wrap .form-control {\n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n    line-height: 30px;\n}\n\n.profile_wrap textarea.form-control {\n    margin-bottom: 20px;\n}\n.flex-fill.form-control {\n    z-index: inherit;\n}\n.input-group-text {\n    border-color: #b5c2cb;\n}\n.main-wrap .small-text {\n    color: #0b3454;\n    font-size: 15px;\n}\n.main-wrap .form-select {\n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n}\n/* madhu modified */\n\n.form-check-input + label.gap-switch {\n    background: #fff;\n    padding: 5px;\n    border-radius: 25px;\n    position: relative;\n    width: 100px;\n    height: 40px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    border: 2px solid #f34e65;\n    color: #f34e65;\n}\n.form-check-input:checked + label.gap-switch {\n    background: #5dae48;\n    border-color: #5dae48;\n}\n.form-check-input + label.gap-switch:before {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    background: #f34e65;\n    border-radius: 50%;\n    content: '';\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + label.gap-switch::before {\n    transform: translateX(62px);\n    -webkit-transform: translateX(62px);\n    -moz-transform: translateX(62px);\n    -ms-transform: translateX(62px);\n    -o-transform: translateX(62px);\n    background: #fff;\n}\n.form-check-input + label.gap-switch:after {\n    content: 'NO';\n    color: #f34e65;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    text-align: center;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.form-check-input:checked + label.gap-switch::after {\n    transform: translateX(-30px);\n    content: 'YES';\n    -webkit-transform: translateX(-30px);\n    -moz-transform: translateX(-30px);\n    -ms-transform: translateX(-30px);\n    -o-transform: translateX(-30px);\n    color: #fff;\n}\n.action_btns {\n    max-width: 650px;\n    background: #f5faff;\n    padding: 20px;\n    border-radius: 5px;\n    margin: 35px 0 0 0px;\n    text-align: center;\n}\n.form-switch .form-check-input:focus,\n.form-switch .form-check-input {\n    --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23F34E65%27/%3e%3c/svg%3e');\n    border: 2px solid #f34e65;\n    cursor: pointer;\n}\n.form-check-input:checked {\n    background-color: #29a745;\n    border-color: #29a745;\n}\n.form-switch .form-check-input:checked:focus {\n    --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e');\n    border: 2px solid #29a745;\n}\n.action_btns button.nextbtn {\n    padding: 0px 30px;\n    font-size: 1.5em;\n    width: 180px;\n    cursor: pointer;\n    border: 0px;\n    position: relative;\n    margin: auto;\n    transition: all 0.25s ease;\n    background: #0b3454;\n    color: #fff;\n    overflow: hidden;\n    border-radius: 25px;\n    height: 45px;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 1px;\n}\n\n.load {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    background: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: inherit;\n    -webkit-border-radius: inherit;\n    -moz-border-radius: inherit;\n    -ms-border-radius: inherit;\n    -o-border-radius: inherit;\n}\n.load::after {\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    width: 30px;\n    height: 30px;\n    border-left: 3px solid transparent;\n    border-bottom: 3px solid transparent;\n    animation: loading1 1s ease infinite;\n    z-index: 10;\n    -webkit-animation: loading1 1s ease infinite;\n}\n.load::before {\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n    border: 3px dashed #fff;\n    width: 30px;\n    height: 30px;\n    border-left: 3px solid transparent;\n    border-bottom: 3px solid transparent;\n    animation: loading1 2s linear infinite;\n    z-index: 5;\n    -webkit-animation: loading1 2s linear infinite;\n}\n\n@keyframes loading1 {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n    }\n}\n.float_horizontal_animate {\n    transform: translatex(0px);\n    animation: float_horizontal 4s ease-in-out infinite;\n    -webkit-animation: float_horizontal 4s ease-in-out infinite;\n}\n\n@keyframes float_horizontal {\n    0% {\n        transform: translatex(0px);\n        -webkit-transform: translatex(0px);\n        -moz-transform: translatex(0px);\n        -ms-transform: translatex(0px);\n        -o-transform: translatex(0px);\n    }\n    50% {\n        transform: translatex(-10px);\n        -webkit-transform: translatex(-10px);\n        -moz-transform: translatex(-10px);\n        -ms-transform: translatex(-10px);\n        -o-transform: translatex(-10px);\n    }\n    100% {\n        transform: translatex(0px);\n        -webkit-transform: translatex(0px);\n        -moz-transform: translatex(0px);\n        -ms-transform: translatex(0px);\n        -o-transform: translatex(0px);\n    }\n}\n\nbutton .loading {\n    opacity: 0;\n    visibility: hidden;\n}\nbutton.activeLoading .loading {\n    visibility: visible;\n    opacity: 1;\n}\n\n.question .form-select.max-100 {\n    max-width: 100%;\n}\n\n.check_box {\n    background: #f5f7f8 0% 0% no-repeat padding-box;\n    border-radius: 6px;\n    min-height: 48px;\n    padding: 12px 20px 10px;\n    margin: 20px 0 -35px 0;\n    max-width: 640px;\n}\n\n.check_box .form-check-input {\n    width: 20px;\n    height: 20px;\n    vertical-align: top;\n    display: inline-block;\n    margin-top: 0.5px;\n    border: 1px solid #0b3454cc;\n}\n.check_box .form-check-input:checked {\n    background-color: #5dae48;\n    border-color: #5dae48;\n}\n.check_box .form-check-input:focus {\n    box-shadow: none;\n}\n\n.datewrap {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n    height: 45px;\n    position: relative;\n    overflow: hidden;\n}\n.daterangePickerList,\n.singledaterangePickerList {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    right: 0;\n    margin: auto;\n    cursor: pointer;\n    opacity: 0;\n}\n.datewrap .arrow {\n    background: #f1f1f1 0% 0% no-repeat padding-box;\n    width: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n/*.datewrap .arrow span {background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z'/%3e%3c/svg%3e\");font-size: 0;width: 25px;height: 25px;}*/\n/* .datewrap .arrow span {\n    background: url(../images/arrow.svg) no-repeat center;\n    font-size: 0;\n    width: 25px;\n    height: 25px;\n} */\n.datewrap .from,\n.datewrap .to {\n    flex: 1;\n}\n/* .datewrap .form-control {\n    height: 100% !important;\n    border: 0 !important;\n    background: #fff url(../images/calendar.svg) no-repeat 10px center;\n} */\n\n/* madhu added */\n.form-control[type='date'] {\n    background: #fff url(../images/calender.svg) no-repeat right 10px center;\n    text-align: left;\n    /* padding-left: 35px; */\n    padding-right: 5px;\n    position: relative;\n}\n.form-control[type='date']::-webkit-calendar-picker-indicator,\n.form-control[type='date']::-moz-calendar-picker-indicator {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: auto;\n    height: auto;\n    color: transparent;\n    background: transparent;\n}\n.form-control.form-date {\n    background-image: url(../images/calender.svg);\n    background-position: center right 15px;\n    background-repeat: no-repeat;\n}\n.form-control.form-search {\n    background-image: url(../images/search.svg);\n    background-size: 14px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 34px;\n}\n/* madhu added */\n\n.form-control.form-linkedin {\n    background-image: url(../images/linkedin.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.form-control.form-facebook {\n    background-image: url(../images/facebook.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.form-control.form-instagram {\n    background-image: url(../images/instagram.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n.form-control.form-twitter {\n    background-image: url(../images/twitter.svg);\n    background-size: 20px;\n    background-repeat: no-repeat;\n    background-position: 13px center;\n    padding-left: 48px;\n}\n\n.datepicker {\n    max-width: 280px;\n    width: 100%;\n    padding: 0;\n}\n.datepicker-years {\n    overflow: hidden;\n    border-radius: 5px;\n}\n.datepicker .table-condensed {\n    width: 100%;\n}\n.datepicker table tr td span {\n    height: auto;\n    line-height: 35px;\n    border-radius: 25px;\n}\n.datepicker thead {\n    background: #f4faff;\n    line-height: 40px;\n}\n.datepicker table tr td span.active.active {\n    background: #5dae48;\n}\n\n.prev {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n    background-size: 16px 12px !important;\n    font-size: 0;\n    width: 50px !important;\n}\n.opacity-0 {\n    opacity: 0;\n}\n.next {\n    background-image: url(\"data:; image/svg+xml,%3csvgxmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n    background-size: 16px 12px !important;\n    font-size: 0;\n    width: 50px !important;\n    transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n}\n.datepicker .datepicker-switch {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 5px;\n}\n\n.form-check.custom-rectbox-radio .form-check-input + label {\n    width: 100%;\n    height: 45px;\n    font-weight: 500;\n    border: 1px solid #b9c2cb;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 5px;\n    padding: 0 14px;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s;\n    -webkit-transition: all 0.3s;\n    -moz-transition: all 0.3s;\n    -ms-transition: all 0.3s;\n    -o-transition: all 0.3s;\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label {\n    background: #5dae48;\n    border: 1px solid #5dae48;\n    color: #fff;\n}\n.custom-rectbox-radio {\n    padding: 0;\n    margin: 0;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.custom-rectbox-radio:not(:last-child) {\n    margin-right: 8px;\n}\n.radio_parent {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n}\n.form-check.custom-rectbox-radio .form-check-input + label:before {\n    content: '';\n    position: absolute;\n    right: 10px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 24px;\n    height: 24px;\n    background: url(../images/male_icon.svg) no-repeat center;\n}\n.form-check.custom-rectbox-radio .form-check-input + label[for='female']:before {\n    background: url(../images/female_icon.svg) no-repeat center;\n}\n.form-check.custom-rectbox-radio .form-check-input:checked + label::before {\n    filter: invert(1) brightness(100);\n    -webkit-filter: invert(1) brightness(100);\n}\n.step_header_wrap {\n    display: none;\n}\n\n.header_container {\n    max-width: 1500px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 25px 0px;\n    width: 96%;\n    flex-wrap: wrap;\n}\n.ful-header {\n    border-bottom: 1px solid #e2e8ef;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 1;\n}\n.header_container .user_name {\n    font-size: 20px;\n}\n.rightSection_header {\n    position: relative;\n}\n.global_wrap {\n    position: relative;\n    margin-left: auto;\n    height: 100%;\n    margin-right: 0px;\n}\n.global_wrap .global {\n    right: 0;\n    top: 0px;\n    bottom: auto;\n}\n\n.scholarship_banner {\n    background: transparent linear-gradient(262deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) 0% 0% no-repeat padding-box;\n    width: 100%;\n    height: 100%;\n}\n.scholarship_container {\n    max-width: 1066px;\n    width: 90%;\n    margin: auto;\n    padding-top: 0px;\n}\n.scholarship_container h2 {\n    font-size: 22px;\n    font-weight: 600;\n    margin-top: 55px;\n}\n.scholarship_container h2 span {\n    position: relative;\n}\n.scholarship_container h2 span:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    background: #5cae48;\n    border-radius: 5px;\n    transition: all 0.5s ease-in-out;\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n}\n.scholarship_detail_list {\n    margin: 24px 0 20px 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n    flex-wrap: wrap;\n}\n.scholarship_detail_list li:not(:last-child) {\n    margin-right: 30px;\n}\n.scholarship_detail_list li {\n    position: relative;\n    padding-left: 27px;\n    margin-bottom: 16px;\n}\n.scholarship_detail_list li:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 2px;\n    width: 20px;\n    height: 18px;\n    background: url(../images/tick.svg) no-repeat 0 0;\n}\n.scholarship_detail_carousel_container {\n    max-width: 1066px;\n    margin: auto;\n    width: 90%;\n}\n.scholarship_detail_carousel {\n    width: 100%;\n    padding: 40px 0;\n}\n.joined_offer_wrap {\n    position: relative;\n    margin-left: 0;\n    margin-bottom: 15px;\n    display: flex;\n}\n.joined_offer_wrap:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 0;\n    right: 0;\n    background: #5cae48;\n    height: 1px;\n}\n.joined_label {\n    position: relative;\n    background: #5cae48 0% 0% no-repeat padding-box;\n    border-radius: 16px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    color: #fff;\n    font-weight: 400;\n    padding: 7px 20px 7px 7px;\n    font-size: 14px;\n}\n.joined_label i {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    background: #fff;\n    border-radius: 50%;\n    margin-right: 7px;\n    position: relative;\n}\n.joined_label i:before {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 5px;\n    border-left: 2px solid #5cae48;\n    border-bottom: 2px solid #5cae48;\n    transform: rotate(-45deg);\n    left: 5px;\n    top: 7px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n/* madhu added */\n.joined_label_noline:before {\n    display: none !important;\n}\n.w-65 {\n    width: 65%;\n}\n/* madhu added */\n\n.offered-univarsity-name {\n    font-size: 28px;\n    line-height: 32px;\n    font-weight: 700;\n}\n.joined_label.didnt-join {\n    background: #0b3454;\n}\n.joined_label.didnt-join i:before {\n    border-left: 2px solid #0b3454;\n    border-bottom: 2px solid #0b3454;\n}\n.joined_offer_wrap.didnt-join:before {\n    background: #0b3454;\n}\n\n.scholarship_block {\n    width: 350px;\n}\n\n.card_profiles {\n    background: transparent linear-gradient(144deg, #edebff 0%, #f6f5ff 100%) 0% 0% no-repeat padding-box;\n    border-radius: 6px;\n    padding: 1px;\n    height: auto;\n    max-height: initial;\n    min-height: initial;\n}\n\n/* madhu added */\n.card_profiles_pink {\n    background: transparent linear-gradient(145deg, #ffe8eb 0%, #fff8f9 100%) 0% 0% no-repeat padding-box !important;\n}\n/* madhu added */\n\n.card_profiles:first-child {\n    margin: 0 0 10px;\n}\n.card_profiles .card_profiles_univarsity {\n    padding: 19px 19px 13px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail {\n    flex: 1;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name > a {\n    border-radius: 50%;\n    overflow: hidden;\n    margin-right: 12px;\n    width: 70px;\n    height: 70px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name a img {\n    width: auto;\n    height: 100%;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 {\n    font-size: 22px;\n    font-weight: 600;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 a {\n    border-radius: 0;\n    text-decoration: none;\n    color: #000;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name .student_detail h2 span {\n    font-size: 15px;\n    font-weight: 500;\n    margin-top: 5px;\n    color: #0b3454;\n}\n.carousel-indicators .dot {\n    width: 10px;\n    height: 10px;\n    background: #0b34541a;\n    border-radius: 50%;\n    margin: 0 4px;\n    padding: 0 !important;\n    border: 0;\n}\n.carousel-indicators .dot.active {\n    background: #0b3454b3;\n}\n.scholarship_block > h3 {\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 10px;\n}\n.scholarship_block > h3 span {\n    font-size: 18px;\n    font-weight: 600;\n    display: block;\n}\n.scholarship_amt_detail {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border-radius: 0px 0px 6px 6px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    -webkit-border-radius: 0px 0px 6px 6px;\n    -moz-border-radius: 0px 0px 6px 6px;\n    -ms-border-radius: 0px 0px 6px 6px;\n    -o-border-radius: 0px 0px 6px 6px;\n}\n.scholarship_amt {\n    font-size: 17px;\n    font-weight: 700;\n}\n.scholarship_label {\n    font-size: 16px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n}\n.scholarship_label i {\n    width: 37px;\n    height: 25px;\n    display: inline-block;\n    background: url(../images/scholarships-hat.jpg) no-repeat 0 0;\n    margin-right: 10px;\n}\n\n.univarsity-block {\n    display: flex;\n    justify-content: center;\n    margin-top: 3px;\n}\n.univarsity-block .univarsity-block-cover {\n    display: flex;\n    align-items: center;\n    max-width: 255px;\n    width: 100%;\n}\n.card_profiles .card_profiles_univarsity .card_profiles_name a img {\n    width: auto;\n    height: 100%;\n}\n.univarsity-block .univarsity-block-cover > a {\n    width: 67px;\n    height: 67px;\n    background: #fff;\n    border-radius: 50%;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border: 1px solid #ddd;\n    margin-right: 10px;\n}\n.univarsity-block .univarsity-block-cover > a img {\n    width: auto;\n    height: 100%;\n}\n.univarsity-block .univarsity-block-cover h3 {\n    flex: 1;\n    margin: 0;\n}\n.univarsity-block .univarsity-block-cover h3 p {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 3px;\n}\n.univarsity-block .univarsity-block-cover h3 p a {\n    text-decoration: none;\n    color: #000;\n}\n.univarsity-block .univarsity-block-cover h3 .course {\n    font-size: 15px;\n    font-weight: 500;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: start;\n}\n.univarsity-block .univarsity-block-cover h3 .course .img-fluid {\n    width: 16px;\n    margin-right: 7px;\n    margin-top: 1px;\n}\n.univarsity-block .univarsity-block-cover h3 .course span {\n    width: calc(100% - 23px);\n}\n\n.scholarship_carousel .owl-dots {\n    display: flex;\n    justify-content: center;\n    margin: 15px;\n}\n.scholarship_carousel .owl-dots .owl-dot {\n    width: 8px;\n    height: 8px;\n    background: #0b34541a;\n    border-radius: 50%;\n    margin: 0 4px;\n}\n.scholarship_carousel .owl-dots .owl-dot.active {\n    background: #0b3454b3;\n}\n\n#skip_pop .modal-dialog {\n    max-width: 600px;\n    border-radius: 10px;\n}\n#skip_pop .modal-content {\n    border-radius: 10px;\n}\n#skip_pop .modal-dialog .modal-body {\n    padding: 40px 0 0 50px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    border-radius: 10px;\n    min-height: 300px;\n}\n.img_pop {\n    position: relative;\n    z-index: 1;\n    float: right;\n}\n#skip_pop .modal-dialog .modal-body h4 {\n    font-size: 22px;\n    font-weight: 600;\n    position: relative;\n    text-transform: uppercase;\n}\n#skip_pop .modal-dialog .modal-body h4::before {\n    content: '';\n    position: absolute;\n    bottom: -17px;\n    width: 50px;\n    height: 3px;\n    background: #5cae48;\n    border-radius: 5px;\n}\n#skip_pop .modal-dialog .modal-body p {\n    font-size: 20px;\n    line-height: 28px;\n    max-width: 318px;\n    margin: 40px 0 0;\n    font-weight: 500;\n}\n#skip_pop .img_pop {\n    position: relative;\n    z-index: 1;\n    float: right;\n    margin-top: -30px;\n    width: 220px;\n    text-align: right;\n    display: flex;\n    align-items: end;\n}\n#skip_pop .modal-footer {\n    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%) 0% 0% no-repeat padding-box;\n    border-radius: 90px 10px 10px 10px;\n    opacity: 1;\n    display: flex;\n    justify-content: start;\n    padding-left: 70px;\n    border: 0;\n    min-height: 90px;\n    position: relative;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin-top: -90px;\n    -webkit-border-radius: 90px 10px 10px 10px;\n    -moz-border-radius: 90px 10px 10px 10px;\n    -ms-border-radius: 90px 10px 10px 10px;\n    -o-border-radius: 90px 10px 10px 10px;\n}\n.btn-goback {\n    background: #5cae48;\n    border-radius: 31px;\n    width: 158px;\n    height: 50px;\n    color: #fff;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    text-decoration: none;\n}\n.btn-goback:hover {\n    background: #27970b;\n    color: #fff;\n}\n.btn-later {\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-later:hover {\n    color: #f34e65;\n}\n.btn-skip {\n    margin: 15px;\n    font-size: 12px;\n    text-decoration: navajowhite;\n    font-weight: 500;\n    color: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    background: no-repeat;\n    border: 0;\n}\n.btn-skip:hover {\n    color: #d42941;\n}\n.modal-backdrop.show {\n    opacity: 0.8;\n}\n\n.multiple_benefits_banner {\n    background: transparent linear-gradient(262deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%) 0% 0% no-repeat padding-box;\n    width: 100%;\n    padding-top: 24px;\n}\n.multiple_benefits_container {\n    max-width: 990px;\n    margin: auto;\n    width: 90%;\n}\n.multiple_benefits_container h2 {\n    font-size: 22px;\n    font-weight: 600;\n    position: relative;\n    margin: 37px 0 25px;\n    line-height: 24px;\n}\n.multiple_benefits_container h2:before {\n    content: '';\n    position: absolute;\n    width: 40px;\n    height: 3px;\n    background: #5cae48;\n    left: 0;\n    bottom: -5px;\n}\n.multiple_benefits_container p {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n    max-width: 490px;\n}\n\n.multiple_benefits_cards_container {\n    max-width: 990px;\n    width: 90%;\n    margin: auto;\n}\n.multiple_benefits_cards {\n    width: 100%;\n    padding: 30px 0;\n}\n.multiple_benefits_cards_container .card {\n    border: 0;\n    border-radius: 6px;\n    /* overflow: hidden; */\n    height: 100%;\n}\n.multiple_benefits_cards_container .card.network-card {\n    background: #fff7f8;\n}\n.multiple_benefits_cards_container .card.event-card {\n    background: #f9f8ff;\n}\n.multiple_benefits_cards_container .card .card-header {\n    padding: 18px 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 144px;\n}\n.multiple_benefits_cards_container .card .card-header .title {\n    font-size: 20px;\n    line-height: 22px;\n    flex: 1;\n    color: #fff;\n}\n.multiple_benefits_cards_container .card .card-header .card-img {\n    width: auto;\n}\n.multiple_benefits_cards_container .card.network-card .card-header {\n    background: #d42941;\n}\n.multiple_benefits_cards_container .card.event-card .card-header {\n    background: #51499c;\n}\n.multiple_benefits_cards_container .card .card-body {\n    padding: 0;\n}\n.card .card-body .benefits_toggle {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.card.network-card .card-body .benefits_toggle {\n    background: #fce4e7;\n}\n.card.event-card .card-body .benefits_toggle {\n    background: #e8e7f0;\n}\n.multiple_benefits_cards_container .card .card-body .benefits_toggle .btn {\n    width: 100%;\n    border-radius: 0;\n    min-height: 56px;\n    display: flex;\n    align-items: center;\n    padding: 15px 20px 15px 30px;\n    font-weight: 500;\n    font-size: 18px;\n    color: #000;\n    border: 0;\n    justify-content: space-between;\n}\n.benefits_toggle .btn:focus {\n    box-shadow: none;\n}\n.benefits_toggle .toggle {\n    width: 15px;\n    height: 15px;\n    position: relative;\n}\n.benefits_toggle .toggle::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 15px;\n    height: 3px;\n    background: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.benefits_toggle .toggle::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 3px;\n    height: 15px;\n    background: #000;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.benefits_toggle .btn[aria-expanded='true'] .toggle::after {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n}\n.multiple_benefits_cards_container .card.network-card .card-body .benefits_toggle .btn {\n    background: #fce4e7;\n}\n.benefit-list {\n    padding: 0px 30px 26px;\n}\n.multiple_benefits_cards_container .card .card-body .benefit_form {\n    padding: 20px 30px 40px;\n}\n.benefit-list ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    font-size: 18px;\n    line-height: 22px;\n}\n.benefit-list ul li {\n    padding-left: 25px;\n    position: relative;\n    margin-bottom: 10px;\n}\n.benefit-list ul li:before {\n    content: '';\n    position: absolute;\n    width: 12px;\n    height: 6px;\n    border-left: 2px solid #000;\n    border-bottom: 2px solid #000;\n    transform: rotate(-45deg);\n    left: 0;\n    top: 7px;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n\n.video-btn {\n    background: #0b3454 0% 0% no-repeat padding-box;\n    border-radius: 25px;\n    padding: 9px 20px;\n    display: inline-flex;\n    text-decoration: none;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    border: 0;\n}\n.video-btn b {\n    width: 16px;\n    height: 16px;\n    background: #fff;\n    border-radius: 50%;\n    margin: 0 0 0 7px;\n    display: inline-block;\n    font-size: 0;\n    position: relative;\n}\n.video-btn b::before {\n    content: '';\n    position: absolute;\n    top: 4px;\n    left: 5.5px;\n    margin: auto;\n    width: 0;\n    border-top: 4px solid transparent;\n    border-bottom: 4px solid transparent;\n    border-left: 5px solid #0b3454;\n    height: 0;\n}\n.video-btn:hover {\n    color: #fff;\n    background: #5bae47;\n}\n.video-btn:hover b::before {\n    border-left: 5px solid #5bae47;\n}\n.form-label {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 500;\n    margin: 0 0 4px;\n}\n.select-option.first-option,\n.select-option.second-option {\n    position: relative;\n}\n.select-option.first-option .form-select,\n.select-option.second-option .form-select {\n    margin-bottom: 20px;\n}\n.form-check-input:checked ~ .select-option.first-option:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    border-bottom: 1px solid #00000016;\n    width: 208%;\n    left: 0;\n}\n.form-check-input:checked ~ .select-option.second-option:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    border-bottom: 1px solid #00000016;\n    width: 208%;\n    right: 0;\n}\n.benefit_form .form-check {\n    margin: 0;\n    padding: 0;\n}\n.benefit_form .form-check .form-check-input[role='switch'] {\n    margin-left: 0;\n}\n.custom_radius_check {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border: 1px solid #0b3454;\n    border-radius: 25px;\n    width: 100%;\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    justify-content: space-between;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.custom_radius_check i {\n    width: 17px;\n    height: 12px;\n    background: url(../images/check-tick.svg) no-repeat 0 0;\n    filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);\n    -webkit-filter: invert(76%) sepia(79%) saturate(0%) hue-rotate(131deg) brightness(94%) contrast(96%);\n}\n.select-option {\n    display: none;\n    width: 100%;\n    position: relative;\n}\n.form-check-input:checked ~ .select-option {\n    display: inline-block;\n}\n.select-option .form-select {\n    margin-top: 16px;\n    border: 1px solid #0b3454;\n    border-radius: 6px;\n    height: 42px;\n}\n.form-check-input:checked + .custom_radius_check {\n    background: #5cae48;\n    border-color: #5cae48;\n    color: #fff;\n}\n.form-check-input:checked + .custom_radius_check i {\n    filter: invert(1) brightness(1);\n    -webkit-filter: invert(1) brightness(1);\n}\n.custom_radius_check::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    border-right: 7px solid transparent;\n    border-left: 7px solid transparent;\n    border-top: 7px solid transparent;\n    width: 0;\n    margin: auto;\n    top: 85%;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    opacity: 0;\n}\n.form-check-input:checked + .custom_radius_check::after {\n    top: 100%;\n    border-top: 7px solid #5cae48;\n    opacity: 1;\n}\n.multiple_benefits_cards_container .action_btns {\n    max-width: 100%;\n    margin: 0;\n}\n.bg-drop {\n    display: none;\n}\nfooter.footer {\n    padding: 15px 0;\n    border-top: 1px solid #eee;\n    background: #fff;\n    position: relative;\n    height: auto;\n}\n.footer-wrap {\n    width: 90%;\n    margin: auto;\n    max-width: 1500px;\n}\n.powerby {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    flex-direction: column;\n    width: 139px;\n}\n\n.pop-dialog {\n    max-width: 700px;\n    width: 90%;\n    margin: auto;\n}\n.modal.show .modal-dialog .pop-content {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n.pop-footer {\n    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%) 0% 0% no-repeat padding-box;\n    border-radius: 90px 0px 10px 10px;\n    opacity: 1;\n    padding: 20px 66px;\n    margin-left: 10px;\n    -webkit-border-radius: 90px 0px 10px 10px;\n    -moz-border-radius: 90px 0px 10px 10px;\n    -ms-border-radius: 90px 0px 10px 10px;\n    -o-border-radius: 90px 0px 10px 10px;\n}\n.pop-body {\n    min-height: 255px;\n    padding: 80px 50px 0;\n}\n.pop-body .img_pop {\n    position: absolute;\n    right: -38px;\n    bottom: 0;\n}\n.pop-dialog h4 {\n    font-size: 22px;\n    font-weight: 600;\n    position: relative;\n    margin: 0 0 35px;\n}\n.pop-dialog h4::before {\n    content: '';\n    position: absolute;\n    bottom: -12px;\n    width: 50px;\n    height: 3px;\n    background: #5cae48;\n    border-radius: 5px;\n}\n.pop-body p {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 22px;\n}\n.pop_step {\n    padding: 0;\n    margin: 40px 0 0;\n    list-style: none;\n}\n.pop_step li {\n    padding: 0 0 30px 53px;\n    line-height: 22px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    font-size: 18px;\n    font-weight: 500;\n}\n.pop_step li b {\n    font-size: 20px;\n    font-weight: 500;\n    margin-bottom: 7px;\n}\n.pop_step li .completed_li {\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #5cae48;\n    left: 0;\n    top: -7px;\n    margin: 0 8px;\n}\n.pop_step li .completed_li:before {\n    content: '';\n    position: absolute;\n    border-left: 3px solid #fff;\n    border-bottom: 3px solid #fff;\n    width: 12px;\n    height: 7px;\n    left: 6px;\n    top: 7px;\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n}\n.pop_step li .edit_li {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    background: #0b3454 url(../images/blue_edit.png) no-repeat center;\n    left: 0;\n    top: 0;\n    border-radius: 50%;\n}\n.pop_step li.pop_completed::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 19px;\n    background: #5cae48;\n    width: 2px;\n    bottom: 0;\n    margin: auto;\n}\n\n.mentoring_contact i {\n    width: 36px;\n    height: 36px;\n    background: #27a7df;\n    display: flex;\n    border-radius: 60px;\n    align-items: center;\n    justify-content: center;\n}\n.btn-update {\n    border: none;\n    padding: 10px 30px;\n    background: #5cae48;\n    border-radius: 25px;\n    color: #ffff;\n    text-transform: uppercase;\n    font-weight: 500;\n    font-weight: 14px;\n    transition: all 0.3s ease-in-out;\n}\n.form-control {\n    max-width: 100%;\n    height: 45px;\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n}\ntextarea.form-control {\n    min-height: 60px;\n}\n.btn-update:hover {\n    background: #43992e;\n}\n.edit_phone .btn-close {\n    font-size: 12px;\n}\n.btn-cancel {\n    background: none;\n    border: 0;\n    padding: 10px 5px;\n    border-radius: 25px;\n    margin-left: 10px;\n    font-weight: 500;\n    color: #828282;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.btn-cancel:hover {\n    color: #000;\n}\n\n@media (max-width: 1199px) {\n    /* .global {bottom: -60px;} */\n    .global.show .unlock {\n        white-space: normal;\n        width: 310px;\n    }\n    .global.show .unlock .text {\n        line-height: 17px;\n        font-size: 16px;\n    }\n    .cta_add {\n        flex-direction: column;\n    }\n    .cta_add .btn-add {\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 991px) {\n    .leftPaneBody {\n        padding: 0 50px;\n    }\n    .rightPaneBodyWrap {\n        padding: 50px 40px;\n    }\n    .action_btns button.nextbtn {\n        width: 150px;\n    }\n    .scholarship_block {\n        width: 100%;\n    }\n    .scholarship_carousel .item {\n        display: flex;\n        justify-content: space-between;\n    }\n    .scholarship_carousel .item .card_profiles {\n        width: 49%;\n        display: flex;\n        flex-direction: column;\n    }\n    .item-wrap {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    .item-wrap .card_profiles {\n        width: 49%;\n        margin: 0;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 992.98px) {\n    .form-check-input:checked ~ .select-option.first-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .form-check-input:checked ~ .select-option.second-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        right: -10%;\n    }\n    .form-check-input:checked ~ .select-option.third-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .select-option.third-option .form-select {\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 767px) {\n    .leftPane {\n        width: 100%;\n    }\n    .leftPaneBody {\n        max-width: 100%;\n        padding: 30px;\n    }\n    .leftPaneBodyWrap {\n        padding: 0px 0 50px;\n    }\n    .rightPane {\n        display: block;\n        width: 100%;\n        box-shadow: 0px -7px 15px #00000026;\n        border-radius: 15px 15px 0px 0px;\n        padding: 45px 0px 0px 25px;\n        cursor: pointer;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 7;\n    }\n    .rightPane.basic-information .rightPaneHeaderWrap {\n        display: none;\n    }\n    .rightPaneBodyWrap {\n        padding: 0;\n        position: static;\n    }\n    .rightPane.basic-information {\n        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%) 0% 0% no-repeat padding-box;\n    }\n    .rightPane.basic-information.undergraduate-college {\n        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) 0% 0% no-repeat padding-box !important;\n    }\n    .rightPane.basic-information .step_1 {\n        width: 100%;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n    }\n    .step_img img {\n        width: auto;\n        height: 128px;\n    }\n    .mobile-step-block[aria-expanded='true'] ~ .step_img {\n        position: absolute;\n        right: 0;\n        border: 0;\n        opacity: 0.2;\n    }\n    .textDetail {\n        flex: 1;\n    }\n    .action_btns {\n        max-width: 90%;\n        margin: auto;\n        width: 100%;\n    }\n    .action_btns.social {\n        margin: auto;\n    }\n    .custom-rectbox-radio {\n        flex: none;\n        width: 130px;\n    }\n    /* madhu modified */\n    .step_header_wrap {\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -webkit-box-wrap: wrap;\n        -moz-box-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        -webkit-wrap: wrap;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        margin: 0;\n        position: fixed;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 9;\n        background: transparent linear-gradient(254deg, #fdfeff 0%, #eff7ff 76%, #dbf1ff 100%) 0% 0% no-repeat padding-box;\n        box-shadow: 0px -7px 15px #00000026;\n        border-radius: 15px 15px 0px 0px;\n        padding: 45px 0px 0px 25px;\n        cursor: pointer;\n        transition: all 0.1s ease-in-out;\n        -webkit-transition: all 0.1s ease-in-out;\n        -moz-transition: all 0.1s ease-in-out;\n        -ms-transition: all 0.1s ease-in-out;\n        -o-transition: all 0.1s ease-in-out;\n        align-items: end;\n    }\n    /* madhu modified */\n\n    /* madhu added */\n    .step_header_wrap_bg-beige {\n        background: transparent linear-gradient(213deg, #fffdf8 0%, #fef6e4 76%, #feeccb 100%) 0% 0% no-repeat padding-box !important;\n    }\n    /* madhu added */\n\n    .step_header_wrap::before,\n    .rightPane::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        width: 50px;\n        height: 2px;\n        background: #727272;\n        margin: auto;\n        top: 20px;\n    }\n\n    .step_header_wrap_img img {\n        height: 128px;\n    }\n    .step_header_wrap_title {\n        padding-top: 15px;\n        flex: 1;\n    }\n    .steps.showTab > h2 {\n        padding: 40px 40px 0;\n    }\n    .steps_questions {\n        /* padding: 0px 40px 40px; */\n        margin-top: 30px;\n        max-width: 100%;\n    }\n    .leftPaneHeaderWrap {\n        justify-content: center;\n        display: flex;\n        flex-direction: column;\n        height: auto;\n    }\n    .leftPaneHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 94%;\n        margin: auto;\n    }\n    .leftPaneHeader .user_name {\n        display: inline-block;\n        font-size: 18px;\n    }\n    .check_box {\n        margin: 20px auto -35px;\n        max-width: 680px;\n        width: 90%;\n    }\n    /* madhu modified */\n    .step_header_wrap_title > h2 {\n        font-size: 18px;\n        font-weight: 600;\n        margin-right: 15px;\n    }\n    /* madhu modified */\n    .step_header_wrap_link {\n        background: transparent;\n        border-radius: 27px;\n        color: #0b3454;\n        text-decoration: none;\n        padding: 3px 20px;\n        transition: all 0.3s ease-in-out;\n        display: inline-block;\n        margin-bottom: 18px;\n        font-weight: 500;\n        border: 2px solid #0b3454;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        -webkit-border-radius: 27px;\n        -moz-border-radius: 27px;\n        -ms-border-radius: 27px;\n        -o-border-radius: 27px;\n        display: inline-block;\n        margin-top: 16px;\n    }\n    .step_header_wrap_link span {\n        transition: all 0.3s ease-in-out;\n    }\n    .step_header_wrap_link .less {\n        font-size: 0;\n    }\n    .step_header_wrap_link:hover {\n        background: #0b3454;\n        color: #fff;\n    }\n    .step_header_wrap.open .step_header_wrap_link {\n        margin-bottom: 20px;\n    }\n\n    /* madhu modified */\n    .listed_points:not(.show) {\n        height: 0;\n        overflow: hidden;\n    }\n    .listed_points ul li {\n        font-size: 16px;\n        font-size: 16px;\n        margin-bottom: 15px;\n        line-height: 19px;\n    }\n    .listed_points ul li:last-child {\n        margin-bottom: 0;\n    }\n    /* madhu modified */\n\n    .mobile-step-block {\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        z-index: 9;\n    }\n    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .more,\n    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .more {\n        font-size: 16px;\n    }\n    .mobile-step-block[aria-expanded='false'] + .step_header_wrap_title .step_header_wrap_link .less,\n    .mobile-step-block[aria-expanded='false'] + .textDetail .step_header_wrap_link .less {\n        font-size: 0;\n    }\n    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .more,\n    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .more {\n        font-size: 0px;\n    }\n    .mobile-step-block[aria-expanded='true'] + .step_header_wrap_title .step_header_wrap_link .less,\n    .mobile-step-block[aria-expanded='true'] + .textDetail .step_header_wrap_link .less {\n        font-size: 16px;\n    }\n    .step_header_wrap_title .listed_points ul li::before {\n        height: 17px;\n    }\n\n    .global {\n        width: 100%;\n        height: 40px;\n        position: relative;\n        margin-bottom: -26px;\n        background: none;\n        border-radius: 0;\n        margin-top: 25px;\n        border-top: 1px solid #e2e8ef;\n        bottom: auto;\n        right: auto;\n    }\n    .global .unlock,\n    .global.show .unlock {\n        width: 100%;\n        right: 0;\n        bottom: 0;\n        border-radius: 0;\n        position: static;\n        opacity: 1;\n    }\n    .progress_svg {\n        width: 70px;\n        height: 70px;\n        position: absolute;\n        right: 30px;\n        top: auto;\n        bottom: 0px;\n        background: #fff;\n        padding: 0;\n        border-radius: 50%;\n        box-shadow: 0px 0px 10px 0 #d3d3d3;\n    }\n    .progress_svg .gaugeMeter {\n        width: 60px !important;\n        height: 60px;\n    }\n    .progress_svg .gaugeMeter canvas {\n        width: 100%;\n        height: 100%;\n    }\n    .progress_svg span {\n        line-height: 60px !important;\n        font-size: 18px !important;\n    }\n    .global_wrap {\n        width: 100%;\n        order: 1;\n    }\n    .global.show .unlock,\n    .global .unlock {\n        white-space: normal;\n    }\n    .global.show .unlock.prize_bg,\n    .global .unlock.prize_bg {\n        width: auto;\n        margin: 0 -2%;\n    }\n    .global.show .unlock .text,\n    .global .unlock .text {\n        width: calc(100% - 140px);\n    }\n    .global .unlock.unlock_blue {\n        border-radius: 0 !important;\n    }\n\n    /* madhu modified */\n    .global .unlock .text {\n        font-size: 16px;\n        font-weight: 500;\n    }\n    /* madhu modified */\n\n    .scholarship_carousel .item {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    .scholarship_block {\n        width: 100%;\n        margin-top: 15px;\n        margin-bottom: 30px;\n        position: relative;\n        z-index: 0;\n    }\n    .scholarship_carousel .item .card_profiles {\n        width: 48%;\n        margin: 0 0 10px;\n        display: flex;\n        flex-direction: column;\n    }\n    .scholarship_amt {\n        font-size: 18px;\n        font-weight: 700;\n    }\n    .scholarship_amt_detail {\n        padding: 20px 15px;\n    }\n    /* madhu modified */\n    .bg-drop {\n        position: fixed;\n        left: 0;\n        right: 0;\n        top: 100%;\n        bottom: 0;\n        margin: auto;\n        background: rgba(0, 0, 0, 0.7);\n        z-index: 6;\n        transition: all 0.1s ease-in-out;\n        display: block;\n    }\n    /* madhu modified */\n    .bg-drop[aria-expanded='true'] {\n        top: 0;\n    }\n\n    .mobile-step-block[aria-expanded='true'] ~ .step_header_wrap_img {\n        position: absolute;\n        right: 0;\n        border: 0;\n        opacity: 0.2;\n    }\n    .scholarship_detail_carousel {\n        padding: 0;\n    }\n    .leftPaneHeaderWrap .global.nobadge {\n        height: 0;\n    }\n    .leftPaneHeaderWrap .global.nobadge .progress_svg {\n        top: -30px;\n    }\n    .global_wrap .global.nobadge {\n        height: auto;\n        border: 0;\n    }\n    .global_wrap .global.nobadge .progress_svg {\n        top: -30px;\n    }\n    footer {\n        margin-bottom: 160px;\n    }\n\n    .pop-body .img_pop {\n        position: static;\n        width: 100%;\n        text-align: center;\n    }\n}\n\n@media (max-width: 575px) {\n    .ful-header + .main-wrap {\n        padding: 30px;\n    }\n    .leftPaneBody {\n        padding: 30px;\n    }\n    /* madhu added */\n    .listed_points {\n        margin-top: 10px;\n        margin-right: 15px;\n    }\n    /* madhu added */\n\n    .leftPaneHeader img {\n        width: 130px;\n    }\n    .header_container img {\n        width: 130px;\n    }\n    .step_header_wrap_title {\n        padding-top: 0;\n    }\n    .steps.showTab > h2 {\n        padding: 30px 25px 0;\n    }\n    .steps_questions {\n        /* padding: 0px 25px 30px; */\n    }\n    .action_btns {\n        max-width: 100%;\n        margin: 0 auto;\n        padding: 10px;\n    }\n    .step_header_wrap_img img {\n        height: 100px;\n        animation: none;\n        -webkit-animation: none;\n    }\n    .leftPaneHeader .user_name span {\n        font-weight: 600;\n        width: 100px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: inline-block;\n        vertical-align: top;\n    }\n    .global .unlock {\n        padding: 12px 0;\n    }\n    .global {\n        height: auto;\n    }\n    .global .unlock {\n        height: auto;\n    }\n    .progress_svg {\n        bottom: 10px;\n        right: 10px;\n    }\n    .global_wrap .progress_svg {\n        right: 0;\n        bottom: 5px;\n    }\n    .scholarship_carousel .item .card_profiles {\n        width: 100%;\n        margin: 0 0 10px;\n    }\n    .scholarship_detail_carousel_container {\n        width: 100%;\n        overflow: hidden;\n    }\n    .joined_offer_wrap {\n        margin-left: 0;\n    }\n    .scholarship_block {\n        width: 100%;\n        margin: auto;\n    }\n    .scholarship_detail_carousel {\n        padding: 0px 0 40px;\n    }\n    .global_wrap .global {\n        top: 0;\n        left: 0px;\n    }\n    .skip_pop .brife {\n        flex: 1;\n    }\n    #skip_pop .modal-footer {\n        margin: 0;\n    }\n    #skip_pop .modal-dialog .modal-body {\n        padding: 30px 0 0 30px;\n    }\n    .action_btns .btn-skip {\n        margin: 18px 18px 0;\n        display: inline-block;\n    }\n    #skip_pop .img_pop {\n        margin-top: 15px;\n        text-align: center;\n        width: 100%;\n        padding-right: 30px;\n    }\n    .form-check-input:checked ~ .select-option.first-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .form-check-input:checked ~ .select-option.second-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        right: -10%;\n    }\n    .form-check-input:checked ~ .select-option.third-option::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid #00000016;\n        width: 208%;\n        left: -10%;\n    }\n    .select-option.third-option .form-select {\n        margin-bottom: 20px;\n    }\n    .global.nobadge {\n        top: auto;\n        bottom: auto;\n        height: 20px;\n        border: 0;\n    }\n    .global.nobadge .progress_svg {\n        top: -23px;\n        bottom: auto;\n        right: 0;\n    }\n    .leftPaneHeaderWrap .global.nobadge .progress_svg {\n        right: 10px;\n        top: -23px;\n    }\n    .global.show .unlock.prize_bg,\n    .global .unlock.prize_bg,\n    .global .unlock.laststep_bg {\n        height: 50px;\n    }\n    .unlock.prize_bg .img,\n    .unlock.laststep_bg .img {\n        margin-bottom: -20px;\n    }\n    .leftPaneHeaderWrap .progress_svg {\n        top: -22px;\n    }\n    .global_wrap .global.nobadge .progress_svg {\n        top: -23px;\n    }\n    .global_wrap .global.nobadge {\n        padding: 10px;\n    }\n    .global .unlock.green_recom_bg {\n        padding: 7px 0;\n    }\n    .global .unlock.green_recom_bg .text {\n        width: calc(100% - 0px);\n        padding: 0 20px 0 0;\n    }\n    .global .unlock.unlock_blue {\n        padding: 0;\n    }\n    .pop-body {\n        padding: 30px 30px 0;\n    }\n    .edit_phone .btn-close {\n        font-size: 12px;\n        position: absolute;\n        top: 0px;\n        right: -10px;\n    }\n    .step_img img {\n        height: auto;\n        width: 125px;\n    }\n    .item-wrap .card_profiles {\n        width: 100%;\n        margin: 0 0 20px;\n    }\n}\n\n@media (max-width: 400px) {\n    .global.show .unlock .text {\n        line-height: 16px;\n        font-size: 13px;\n    }\n}\n\n/* madhu added */\n\n.cta_add {\n    display: flex;\n    font-size: 16px;\n    font-weight: 500;\n}\n.cta_add .form-check label {\n    color: #0b3454;\n}\n.cta_add .form-check input {\n    border: 2px solid #0b3454;\n    width: 22px;\n    height: 22px;\n    border-radius: 40px;\n    margin-right: 10px;\n}\n.cta_add .form-check-input:checked {\n    background-color: #27970b;\n    border: 0 !important;\n}\n.cta_add .form-check label {\n    padding-top: 3px;\n    color: #0b3454;\n}\n.cta_add .btn-add {\n    color: #27a7df;\n    padding: 0 30px 0 0;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n}\n.cta_add .btn-add:hover {\n    color: #5cae48;\n}\n.cta_add .btn-add i {\n    margin-right: 10px;\n    margin-top: -4px;\n}\n.cta_add .btn-add i path {\n    fill: #5cae48;\n    color: #5cae48;\n}\n.cta_add .btn-add:focus {\n    box-shadow: none;\n}\n.cta_add .btn-add:focus-visible {\n    border: none;\n    outline: none;\n}\n.cta_add .btn-add:hover i img {\n    filter: invert(54%) sepia(94%) saturate(312%) hue-rotate(63deg) brightness(93%) contrast(83%);\n}\n\n.btn-delete {\n    padding: 0;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    left: 100%;\n    top: 15px;\n    opacity: 0.4;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    background: transparent\n        url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z'/%3e%3c/svg%3e\")\n        0 0 / 18px auto no-repeat;\n}\n.btn-delete:hover {\n    opacity: 1;\n}\n.form-label ~ .btn-delete {\n    top: 45px;\n}\n\n.section {\n    position: relative;\n\n    padding-right: 20px;\n}\n.section + .section {\n    margin-top: 60px;\n}\n.section:first-child {\n    margin-top: 20px;\n}\n\n.section .btn-delete {\n    top: 35px;\n    bottom: 0;\n    margin: auto;\n    right: -60px;\n}\n.section::after {\n    content: '';\n    position: absolute;\n    right: -2px;\n    top: 23px;\n    bottom: 0;\n    width: 1px;\n    height: calc(100% - 23px);\n    background: #e2e8ef;\n}\n\n@media (max-width: 767px) {\n    .cta_add {\n        display: block;\n    }\n    .cta_add .btn-add {\n        margin-bottom: 10px;\n    }\n    .section {\n        width: calc(100% - 25px);\n    }\n    .section .btn-delete {\n        right: -50px;\n    }\n}\n\n.font-18 {\n    font-size: 18px;\n}\n.mentoring_contact {\n    border: 1px solid #b5c1cb;\n    border-radius: 6px;\n}\n.mentoring_contact p {\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n    font-weight: 500;\n}\n.mentoring_contact p i {\n    width: 36px;\n    height: 36px;\n    background: #27a7df;\n    display: flex;\n    border-radius: 60px;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n}\n.mentoring_contact p i img {\n    /* height: auto; */\n}\n\n.card_achievements {\n    text-align: center;\n}\n.card_achievements .card_profiles_name {\n    display: block !important;\n}\n.card_achievements .card_profiles_univarsity .card_profiles_name > a {\n    margin: 0 auto;\n    margin-bottom: -47px;\n    width: 80px;\n    height: 80px;\n    position: relative;\n    overflow: inherit; /* z-index: 9999; */\n}\n.card_achievements .scholarship_amt {\n    margin: 0 auto;\n    margin-top: 30px;\n    font-size: 18px;\n}\n.card_achievements .card_profiles_univarsity .card_profiles_name > a span {\n    background: url(../images/badge.svg) no-repeat center;\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    width: 20px;\n    height: 28px;\n    margin-left: -10px;\n    bottom: -15px;\n}\n.card_achievements .card_profiles_univarsity .card_profiles_name > a img {\n    border-radius: 50%;\n}\n\n/* madhu added */\n\n.profile_picture_qr {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    min-height: 242px;\n    border-radius: 10px;\n    overflow: hidden;\n}\n.profile_picture_qr .or {\n    width: 2px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n.profile_picture_qr .profile_picture_section {\n    background: #d42941;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 15px;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    position: relative;\n}\n.profile_picture_qr .profile_picture_section:hover {\n    background: #bd1f35;\n}\n.profile_picture_qr .profile_picture_section .block {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    cursor: pointer;\n    z-index: 1;\n}\n.profile_picture_qr .qr_section {\n    flex: 1;\n    background: #cffed2;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.profile_picture_qr .or span {\n    background: #fff;\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    position: absolute;\n    left: -21px;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n.profile_picture_qr .or::after {\n    display: none;\n}\n.profile_picture_edit {\n    border: 2px dashed #ffffff;\n    border-radius: 74px;\n    width: 145px;\n    height: 145px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 0 0 5px #d42941 inset;\n    position: relative;\n}\n.profile_picture_edit:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 100%;\n    background: #fff;\n    border-radius: 50%;\n    z-index: 0;\n}\n.profile_picture_edit img {\n    width: 100%;\n    position: relative;\n}\n.profile_picture_edit .image-edit {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 32px;\n    height: 32px;\n    background: #5cae48;\n    border: 3px solid #fff;\n    border-radius: 50%;\n    transition: all 0.3s ease-in-out;\n}\n.profile_picture_edit .image-edit:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    height: 12px;\n    background: #fff;\n    margin: auto;\n}\n.profile_picture_edit .image-edit:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 12px;\n    height: 2px;\n    background: #fff;\n    margin: auto;\n}\n.profile_picture_edit .image-edit:hover {\n    background: #669f34;\n}\n.profile_picture_edit_btn {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n}\n.profile_picture_edit_btn label {\n    background: #ffe3e3 0% 0% no-repeat padding-box;\n    border: 2px solid #ffffff;\n    border-radius: 60px;\n    font-size: 12px;\n    font-weight: 500;\n    width: 140px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.profile_picture_section:hover .profile_picture_edit_btn label {\n    background: #f7b3b3;\n    border: 2px solid#F7B3B3;\n}\n.profile_picture_edit_btn span {\n    font-size: 14px;\n    color: #fff;\n    line-height: 18px;\n}\n.profile_picture_qr .qr_section p {\n    font-size: 16px;\n    margin: 8px 0 0;\n    font-weight: 500;\n}\n.whatapp_text i {\n    width: 20px;\n    height: 20px;\n    margin-right: 5px;\n    background: url(../images/whatsapp.svg) no-repeat 0 0;\n}\n.whatapp_text {\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    font-size: 16px;\n    font-weight: 600;\n    align-items: center;\n}\n.desclamier {\n    font-size: 14px;\n    font-style: italic;\n    margin: 10px 0 20px;\n}\n\n@media (min-width: 768px) and (max-width: 992.98px) {\n    .profile_picture_qr {\n        flex-direction: column;\n    }\n    .profile_picture_qr .profile_picture_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .qr_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .or {\n        width: 100%;\n    }\n    .profile_picture_qr .or span {\n        left: 0;\n        right: 0;\n    }\n}\n\n@media (max-width: 575px) {\n    .profile_picture_qr {\n        flex-direction: column;\n    }\n    .profile_picture_qr .profile_picture_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .qr_section {\n        padding: 30px;\n    }\n    .profile_picture_qr .or {\n        width: 100%;\n    }\n    .profile_picture_qr .or span {\n        left: 0;\n        right: 0;\n    }\n    .btn-delete {\n        right: -20px;\n    }\n}\n\n.success_popup {\n    max-width: 700px;\n}\n.success_popup .img_pop {\n    position: absolute;\n    right: -40px;\n    bottom: 0;\n}\n.success_popup .modal-content {\n    min-height: 380px;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n.success_popup .modal-body {\n    display: flex;\n    align-items: center;\n    padding-left: 60px;\n}\n.success_popup .brife {\n    margin-top: -30px;\n    max-width: 320px;\n}\n.success_popup .modal-body h4::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    width: 50px;\n    height: 3px;\n    background: #5cae48;\n    border-radius: 15px;\n}\n.success_popup .modal-body h4 {\n    position: relative;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n}\n.success_popup .modal-footer {\n    background: transparent linear-gradient(261deg, #fdfeff 0%, #eff7ff 16%, #d4ffc9 100%) 0% 0% no-repeat padding-box;\n    border-radius: 90px 10px 10px 10px;\n    opacity: 1;\n    display: flex;\n    justify-content: start;\n    padding-left: 70px;\n    border: 0;\n    min-height: 90px;\n    position: relative;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin-top: -90px;\n    -webkit-border-radius: 90px 10px 10px 10px;\n    -moz-border-radius: 90px 10px 10px 10px;\n    -ms-border-radius: 90px 10px 10px 10px;\n    -o-border-radius: 90px 10px 10px 10px;\n}\n.file {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.file > input[type='file'] {\n    display: none;\n}\n.file > label {\n    font-size: 1rem;\n    font-weight: 300;\n    cursor: pointer;\n    outline: 0;\n    user-select: none;\n    border-radius: 6px;\n    padding-right: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    border: 1px dotted #8499a9;\n    min-height: 60px;\n    padding: 0;\n    font-weight: 400;\n    color: #0b3454;\n}\n.file > label span {\n    padding-left: 5px;\n    text-decoration: underline;\n    color: #27a7df;\n    font-weight: 400;\n}\n.file > label:hover {\n    border-color: hsl(0, 0%, 21%);\n}\n.file > label:active {\n    background-color: hsl(0, 0%, 96%);\n}\n.file > label > i {\n    padding-right: 15px;\n}\n.file--upload > label {\n}\n.file--upload > label:hover {\n    border-color: hsl(204, 86%, 53%);\n    background-color: hsl(204, 86%, 96%);\n}\n.file--upload > label:active {\n    background-color: hsl(204, 86%, 91%);\n}\n.file--uploading > label {\n    color: hsl(48, 100%, 67%);\n    border-color: hsl(48, 100%, 67%);\n}\n.file--uploading > label > i {\n    animation: pulse 5s infinite;\n}\n.file--uploading > label:hover {\n    border-color: hsl(48, 100%, 67%);\n    background-color: hsl(48, 100%, 96%);\n}\n.file--uploading > label:active {\n    background-color: hsl(48, 100%, 91%);\n}\nform-control.is-valid,\n.was-validated .form-control:valid {\n    background-image: none;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]) {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n}\n.form-select.is-valid,\n.was-validated .form-select:valid {\n    color: #000;\n}\n\n.question .form-select.customSelect {\n    border: 1px solid #b5c2cb;\n    border-radius: 6px;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.customChoose {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 10px 20px #efefef;\n    border: 1px solid #b5c1cb;\n    border-radius: 6px;\n    overflow: hidden;\n    position: absolute;\n    width: 100%;\n    top: 150%;\n    z-index: -1;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n}\n.question .customChoose .form-control {\n    border-width: 0 0 1px 0;\n    border-radius: 0;\n}\n.customChoose.open {\n    opacity: 1;\n    z-index: 1;\n    top: 102%;\n}\n.customChooseoptions {\n    margin: 20px 0 20px;\n    padding: 0 15px;\n    list-style: none;\n    max-height: 160px;\n    overflow: auto;\n    line-height: 16px;\n    scrollbar-width: 4px;\n}\n/* Works on Chrome, Edge, and Safari */\n.customChooseoptions::-webkit-scrollbar {\n    width: 4px;\n}\n.customChooseoptions::-moz-scrollbar {\n    width: 4px;\n}\n.customChooseoptions::-webkit-scrollbar-track {\n    background: #eee;\n}\n.customChooseoptions::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #eee;\n}\n.customChooseoptions li {\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 16px;\n}\n.customChooseoptions li:hover {\n    color: #5cae48;\n}\n.customChooseoptions li:not(:last-child) {\n    margin-bottom: 12px;\n}\n.customInputSearch + .customChoose.open,\n.customInputSearch:focus + .customChoose {\n    opacity: 1;\n    top: 102%;\n    z-index: 1;\n}\n\n.input-group-customSelect {\n    width: 33.3%;\n}\n.input-group .customSelect {\n    border-radius: 6px 0 0 6px !important;\n}\n.input-group-customSelect:not(:first-child) label {\n    border-radius: 0 !important;\n}\n.form-select.CurrencySelect.customSelect ~ .customChoose {\n    width: 168px;\n    border-radius: 6px !important;\n}\n\n#login_pop .signup,\n#sociallogin,\n.bg_side_blue .signup {\n    background: #0b3454;\n    margin-right: -1px;\n    border-radius: 0px 18px 18px 80px;\n}\n#login_pop .signup h1 {\n    font-family: 'Jost', sans-serif;\n    color: #fff;\n}\n#login_pop .signup:before {\n    display: none;\n}\n#login_pop .signup .title {\n    position: relative;\n}\n#login_pop .innercover {\n    max-width: 385px;\n    width: 90%;\n    margin: auto;\n    padding: 0 20px;\n}\n#login_pop .innercover .img {\n    display: flex;\n    height: auto;\n    align-items: flex-end;\n    margin-bottom: 37px;\n    justify-content: center;\n}\n.innercover .img img {\n    max-width: 200px;\n}\n.icon.icon-correct::before {\n    content: '';\n    width: 13px;\n    height: 7px;\n    border-left: 2px solid #98bbdf;\n    border-bottom: 2px solid #98bbdf;\n    display: inline-block;\n    transform: rotate(-40deg);\n    margin: 7px 3px 0 0;\n    vertical-align: top;\n}\n.signup form .form-check-label {\n    cursor: pointer;\n}\n.form-group label[onclick] {\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.form-group.form-control-email::before {\n    width: 16px;\n    height: 12px;\n    content: '';\n    background: url(../images/form-email.svg) no-repeat 0 center;\n    position: absolute;\n    top: 15px;\n    bottom: auto;\n    margin: auto;\n    left: 16px;\n    z-index: 2;\n}\n.form-group.form-control-password::before {\n    width: 12px;\n    height: 16px;\n    content: '';\n    background: url(../images/form-lock.svg) no-repeat 0 center;\n    position: absolute;\n    top: 15px;\n    bottom: auto;\n    margin: auto;\n    left: 19px;\n    z-index: 2;\n}\n/* .form-group.form-control-mobile::before {\n    width: 9px;\n    height: 16px;\n    content: '';\n    background: url(../images/form-cell-phone.svg) no-repeat 0 center;\n    position: absolute;\n    top: 15px;\n    bottom: auto;\n    margin: auto;\n    left: 16px;\n    z-index: 2;\n} */\n.form-group label[onclick]:hover,\n.signup form .form-check-label[for='exampleCheck1']:hover,\n.signup a:hover {\n    color: #5cae48 !important;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    text-decoration: none;\n}\nform a:hover {\n    text-decoration: none;\n}\n.form-group label[onclick]:hover {\n    color: #5cae48 !important;\n}\n.signup form .form-check-input:not(#exampleCheck1):checked + label.form-check-label {\n    background: #217aff !important;\n    border-color: #217aff !important;\n    color: #fff;\n}\n.signup form .form-check-input:checked + label .icon.icon-correct::before {\n    border-color: #fff !important;\n}\n.signup form .form-control {\n    min-height: 40px;\n    border: none;\n    border-radius: 6px;\n    font-weight: 500;\n    color: #000;\n    font-family: 'Jost', sans-serif;\n    font-size: 16px;\n    z-index: 1;\n    position: relative;\n}\n.signup #existing-user form .form-control {\n    padding-left: 50px;\n}\n.signup #existing-user form .form-control#ShopLoginFormModel_email {\n    background: #fff url(../images/form-email.svg) no-repeat 16px center;\n}\n/* .signup #existing-user form .form-control#ShopLoginFormModel_mobile {\n    background: #fff url(../images/form-cell-phone.svg) no-repeat 16px center;\n} */\n.email-text {\n    color: #ffffff99;\n}\n.signup #existing-user form .form-control#ShopLoginFormModel_password,\n.signup #existing-user form .form-control#ShopSignupFormModel_password {\n    background: #fff url(../images/form-lock.svg) no-repeat 19px center;\n}\n.signup #existing-user form .form-control#ShopSignupFormModel_first_name,\n/* .signup #existing-user form .form-control#ShopSignupFormModel_last_name {\n    background: #fff url(../images/form-user.svg) no-repeat 19px center;\n} */\n/* .signup #existing-user form .form-control#ShopSignupFormModel_present_class {\n    background: #fff url(../images/form-measure.svg) no-repeat 16px center;\n} */\n/* .signup #existing-user form .form-control#ShopSignupFormModel_board_id {\n    background: #fff url(../images/form-open-book.svg) no-repeat 16px center;\n} */\n/* .signup #existing-user form .form-control#ShopSignupFormModel_country_code {\n    background: #fff url(../images/form-globe.svg) no-repeat 16px center;\n} */\n/* .signup #existing-user form .form-control#ShopSignupFormModel_mobile_number {\n    background: #fff url(../images/form-cell-phone.svg) no-repeat 16px center;\n} */\n.signup form .form-group {\n    position: relative;\n}\n.signup form .form-group .viewpassword {\n    position: absolute;\n    right: 15px;\n    bottom: auto;\n    top: 14px;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    z-index: 2;\n}\n.signup form .form-control + .viewpassword::before {\n    content: '';\n    width: 0%;\n    height: 2px;\n    background: #022d6d;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    transform: rotate(45deg);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.signup form .form-control[type='text'] + .viewpassword::before {\n    width: 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.signup form .form-check-input {\n    width: 1em;\n    height: 1em;\n    margin-top: 0.25em;\n    vertical-align: top;\n    background-color: #fff;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    -webkit-print-color-adjust: exact;\n    color-adjust: exact;\n    transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n.signup form .form-check .form-check-input {\n    float: left;\n    margin-left: -1.5em;\n}\n.signup form .form-check-input[type='checkbox'] {\n    border-radius: 0.25em;\n}\n.signup form .form-check-input:checked {\n    background-color: #7fb507;\n    border-color: #7fb507;\n}\n.signup form .form-check-input:checked[type='checkbox'] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.signup .owl-dots .owl-dot {\n    box-shadow: 0 0 0 0;\n}\n.signup .owl-theme .owl-dots .owl-dot.active span,\n.signup .owl-theme .owl-dots .owl-dot:hover span {\n    background: #585858;\n    opacity: 0.8;\n}\n.login-footer {\n    margin: 50px 0;\n}\n.login-footer p {\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n    position: relative;\n}\n.login-footer p::after {\n    background: #c5c5c5;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    bottom: 7px;\n    margin: auto;\n    content: '';\n    left: 0;\n    right: 0;\n}\n.login-footer p b {\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    padding-right: 15px;\n}\n.login-footer > span {\n    color: #060606;\n    font-size: 12px;\n    line-height: 16px;\n    opacity: 0.6;\n}\n.signup .or {\n    margin: 0 0 20px;\n    text-align: center;\n    display: inline-block;\n    width: 100%;\n    font-size: 18px;\n    line-height: 22px;\n    color: #fff;\n    position: relative;\n}\n#existing-user.active ~ div .btn-signin {\n    display: none;\n}\n.input-otp {\n    max-width: 60px;\n    width: 100%;\n    outline: none;\n    box-shadow: none;\n}\n#new-user.active ~ div .btn-signup {\n    display: none;\n}\n#new-user .nav-pills .nav-link {\n    background: #fff;\n    width: 100%;\n}\n#new-user .nav-pills .nav-link.active {\n    background: #217aff;\n}\n#new-user ul.nav-pills li {\n    width: 30%;\n}\n#new-user .nav-pills .nav-link.active .icon.icon-correct::before {\n    border-color: #fff !important;\n}\n#pills-others.active + div {\n    display: none;\n}\n.or::after {\n    background: #38566e;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    bottom: 7px;\n    margin: auto;\n    content: '';\n    left: 0;\n    right: 0;\n    max-width: 463px;\n}\n.signup .or b {\n    font-weight: 400;\n    font-family: 'Jost', sans-serif;\n    background: #0b3454;\n    position: relative;\n    z-index: 2;\n    padding: 0 10px;\n}\n.sociallnks {\n    text-align: center;\n}\n.sociallnks p {\n    font-size: 14px;\n    line-height: 17px;\n    color: #fff;\n    font-family: 'Jost', sans-serif;\n    margin: 0;\n    font-weight: 400;\n}\n.sociallnks p a {\n    color: #a2e609;\n    font-weight: 500;\n}\n.sociallnks p a:hover {\n    text-decoration: none;\n}\n.sociallinks ul {\n    list-style: none;\n}\n.sociallnks ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-wrap: wrap;\n    -moz-box-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -webkit-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.sociallnks ul li a {\n    background: #ffffff;\n    box-shadow: 0px 5px 10px #0000001a;\n    border-radius: 18px;\n    width: 100%;\n    display: flex;\n    height: 36px;\n    justify-content: center;\n    align-items: center;\n}\n.sociallnks ul li {\n    width: 100px;\n    margin: 20px 10px;\n}\n.signup form .gendar-radio-button + label {\n    float: left;\n    padding: 0.5em 1em;\n    cursor: pointer;\n    border: 1px solid #28608f;\n    margin-right: -1px;\n    color: #000;\n    background-color: #ffffff;\n    width: 100%;\n    border-radius: 6px;\n    min-height: 40px;\n    display: flex;\n    align-items: center;\n    border: none;\n}\n.signup form .error .error-valid-text {\n    color: #fff !important;\n    margin-top: 3px;\n}\n.signup form .error .form-control {\n    background-color: #f7d7d7 !important;\n    border: 1px solid #fd7373;\n}\n/* .signup form .gendar-radio-button + label[for='maleBtn'] {\n    background: #fff url(../images/form-male_blue.svg) no-repeat 16px center;\n    padding-left: 50px;\n} */\n/* .signup form .gendar-radio-button + label[for='femaleBtn'] {\n    background: #fff url(../images/form-female_blue.svg) no-repeat 16px center;\n    padding-left: 50px;\n} */\n/* .signup form .gendar-radio-button:checked + label[for='maleBtn'] {\n    background: #1074e9 url(../images/form-male_white.svg) no-repeat 16px center;\n} */\n/* .signup form .gendar-radio-button:checked + label[for='femaleBtn'] {\n    background: #1074e9 url(../images/form-female_white.svg) no-repeat 16px center;\n} */\n.signup form .gendar-radio-button + label:first-of-type {\n}\n.signup form .gendar-radio-button + label:last-of-type {\n}\n.signup form .gendar-radio-button:checked + label {\n    background-color: #1074e9;\n    color: #fff;\n}\n.btn-access {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n#new-user .progress {\n    height: 6px;\n    background: #051c3e;\n}\n#new-user a#but_add {\n    cursor: pointer;\n}\n#myloginTab {\n    display: flex;\n}\n#myloginTab li {\n    flex: 2;\n}\n#myloginTab li button {\n    width: 100%;\n    border: 0;\n    border-radius: 0;\n    line-height: 70px;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: 'Jost', sans-serif;\n    background: #04243c;\n    color: rgba(255, 255, 255, 0.5);\n}\n#myloginTab li button.active {\n    background: #0b3454;\n    color: #fff;\n}\n.daterangepicker .calendar-table th {\n    background-image: none;\n}\n.daterangepicker .calendar-table .next span {\n    transform: rotate(130deg);\n    -webkit-transform: rotate(130deg);\n}\n\n.page_loader {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 5;\n}\n.page_loader .sr-only {\n    font-size: 0;\n}\n.page_loader .spinner-border {\n    border-color: #fff #fff #fff transparent;\n    width: 100px;\n    height: 100px;\n    border-width: 10px;\n}\n\n.css-b62m3t-container .css-t3ipsp-control,\n.css-b62m3t-container,\n.css-13cymwt-control {\n    height: 43px !important;\n    border: 0 !important;\n}\ndiv.css-9kqgro-control,\ndiv.css-xpesdl-control,\ndiv.css-9kqgro-control {\n    min-height: 38px !important;\n    margin-top: 1px;\n    margin-right: 1px;\n}\ndiv.css-1fdsijx-ValueContainer {\n    padding: 0;\n}\ndiv.css-3w2yfm-ValueContainer {\n    display: inline-block;\n    overflow: hidden;\n    padding-left: 8px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow-x: auto;\n    scrollbar-width: thin;\n}\n\ndiv.css-3w2yfm-ValueContainer::-webkit-scrollbar {\n    height: 3px;\n}\ndiv.css-3w2yfm-ValueContainer::-moz-scrollbar {\n    height: 3px;\n}\ndiv.css-3w2yfm-ValueContainer::-webkit-scrollbar-track {\n    background: #ccc;\n}\ndiv.css-3w2yfm-ValueContainer::-webkit-scrollbar-thumb {\n    background-color: #666;\n    border-radius: 20px;\n    border: 2px solid #666;\n}\ndiv.css-1p3m7a8-multiValue {\n    display: inline-flex;\n}\n.delete-sticky {\n    position: sticky;\n    top: 147px;\n    right: 0;\n    text-align: right;\n    cursor: pointer;\n}\n.blue-tick {\n    color: blue;\n}\n.header_container img {\n    height: 100%;\n    width: auto;\n    max-height: 42px;\n}\n\n.school_logo {\n    max-height: 70px;\n}\n\n.alumni-welcome-image-logo {\n    height: 60px;\n    border-radius: 50%;\n    width: 60px;\n}\n\n.btn-blue {\n    background: #0b3c54;\n    border-radius: 27px;\n    height: 40px;\n    padding: 0 25px;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    border: 0;\n}\n\n.relevantAlumniMatch .btn-complete-now {\n    border: 1px solid #d42941;\n    border-radius: 25px;\n    width: 160px;\n    height: 40px;\n    background: #fff;\n    color: #000;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 500;\n    margin-right: 23px;\n    transition: all 0.3s ease-in-out;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    text-decoration: none;\n}\n.sucess-message {\n    color: white !important;\n}\n.error-message {\n    color: red !important;\n}\n\n.mention-dropdown {\n    border: 1px solid #ccc;\n    background-color: white;\n    z-index: 1000;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.mention-option {\n    padding: 8px 12px;\n    cursor: pointer;\n}\n\n.mention-option:hover {\n    background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
